import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import { Redirect } from "react-router-dom";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/themes/light.css";
import MicroModal from "micromodal";
import ReactDOM from "react-dom";
import {
  SolicitarChamada,
  ShowInfoDisplay,
  dbfileSize,
  GetHistory,
  CarregamentoInteractions,
  DetailsAnotationsida,
  DetailsFileShared,
  DetailsMarkstarida,
  DownloadFile,
  ActionRefreshNoAnswer,
  SearchingHistoryData,
  InterationNotifier,
} from "../actions";
import { RefreshNoAnswerCall } from "../actions/websocket";
import FACEBOOK from "../build/images/facebook_icon.svg";
import AVI from "../build/images/avi-file.png";
import FACEBOOKNEW from "../build/images/facebook_new.svg";
import Highlighter from "react-highlight-words";
import WHATSAPP from "../build/images/whatsapp_icon.svg";
import WHATSAPPNEW from "../build/images/whatsapp_new.svg";
import WEBCHAT from "../build/images/webchat.svg";
import WEBCHATNEW from "../build/images/webchat-new.svg";
import PHONE from "../build/images/voz_icon.svg";
import PHONENEW from "../build/images/callchat-new.svg";
import DEFAULT from "../build/images/default.png";
import Lightbox from "react-image-lightbox";
import JPG from "../build/images/jpg-file.png";
import XLS from "../build/images/media-icon.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import latinize from "latinize";
import { Topover, Popover } from "../actions/Tippy";
import _ from "lodash";
import TimeCounterMinute from "../containers/TimeCounterMinute";
import DeleteCallModal from "../modals/DeleteCallModal";
import ICONPDFEXPORT from "../build/images/pdf.svg";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import PdfDocument from "../components/templates/PdfDocument";
import VIDEO from "../build/images/video.jpg";
import AUDIO from "../build/images/audio.svg";
import FOTO from "../build/images/foto.svg";
import DOC from "../build/images/doc.svg";

import TWITTER from "../build/images/twitter-new.svg";
import MIDIAEMAIL from "../build/images/email-new.svg";
import MIDIATELEGRAM from "../build/images/telegram-new.svg";
import GOOGLEGBM from "../build/images/googlegbm-new.svg";
import LINKEDIN from "../build/images/linkedin-new.svg";
import INSTAGRAM from "../build/images/instagram_new.svg";
import TEAMS from "../build/images/channelsNew/teamsBig.svg";

const { meses } = require("../services/data");

const { connection_platform } = require("../services/api");
var TimeFormat = require("hh-mm-ss");
var checkFiltro = false;
var sortAtual =
  localStorage.getItem("managerdashboard_filter_sortname") || "qtde_recebidas";
var sort = localStorage.getItem("managerdashboard_filter_ordersort") || "desc";
var chars = "";
var checkSLA = false;
var valorSLA = 0;
var keycount = 1;

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var checkreply = false;
var jsonSRV = "";

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  if (parseInt(connection_platform.port_apache_view_extern) != 80) {
    ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  }
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  if (parseInt(connection_platform.port_apache_view_intern) != 80) {
    ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  }
}

MicroModal.init();

function isJson(item) {
  item = typeof item != "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item != null) {
    return true;
  }

  return false;
}

function createJSON(item) {
  if (item !== "" && item !== 0) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const mapStateToProps = (state) => {
  return {
    VerificarUser: state.informationusers,
    InfoUsers: state.informationusers,
    HistoryUser: state.historycalls,
    listCallQueue: state.listcallqueue,
    UserGroups: state.groups,
    servicegroup: state.servicegroup,
    listmidias: state.midias,
    filtrogrupo: state.servicoagrupado,
    gruposatd: state.groups,
    IPCurrent: state.ipcurrent,
    StatusAgent: state.status,
    CriticidadesAnotacoes: state.criticalitys,
    PermissionRouter: state.routergroups,
    OutBandService: state.outservices,
    DisplayNextAtd: state.displaynextatd,
    DetailsAnotations: state.detailsanotations,
    DetailsMarkstar: state.detailsmarkstars,
    DetailsFileShared: state.detailsfileshared,
    History: state.history,
    CallBack: state.callback,
    AtdSimult: state.atdsimult,
    FilterManager: state.filtersmanager,
  };
};

const mapDispatchToProps = (dispatch) => ({
  SolicitarChamada: (
    InfoUsers,
    scriptid,
    cdrid,
    mediaid,
    status,
    StatusAgent
  ) => {
    if (StatusAgent.allowCapture === false) {
      dispatch(InterationNotifier("Pausa não permite captura", "permission"));
    } else {
      dispatch(
        SolicitarChamada(
          InfoUsers,
          scriptid,
          cdrid,
          mediaid,
          status,
          StatusAgent
        )
      );
      dispatch(ShowInfoDisplay("Clientes"));
    }
  },
  ClearHistory: (post) => {
    dispatch(GetHistory([]));
  },
  CarregamentoInteractions: (cdr, idgroup) => {
    CarregamentoInteractions(cdr, idgroup)(dispatch);
  },
  DetailsAnotationsida: (datainit, datafim, idcriticidade, telefone) => {
    dispatch(DetailsAnotationsida(datainit, datafim, idcriticidade, telefone));
  },
  DetailsFileSharedIn: (datainit, datafim, formats, midias, telefone) => {
    dispatch(DetailsFileShared(datainit, datafim, formats, midias, telefone));
  },
  DetailsMarkstarida: (datainit, datafim, telefone) => {
    dispatch(DetailsMarkstarida(datainit, datafim, telefone));
  },
  DonwloadFileIn: (url, name) => {
    DownloadFile(url, name)(dispatch);
  },
  PropsRefreshNoAnswer: (cdrid, queueid, infousers) => {
    dispatch(ActionRefreshNoAnswer(queueid));
    RefreshNoAnswerCall(cdrid, queueid, infousers);
  },
  SearchingHistory: (histstart, histend, telefone, cdrid, idgroup) => {
    dispatch(
      SearchingHistoryData(histstart, histend, cdrid, telefone, idgroup)
    );
  },
});

class Manager extends Component {
  constructor(props) {
    var storageTypeService =
      localStorage.getItem("dashboard_monitoring_typeservice") || [];
    if (storageTypeService.length !== 0) {
      storageTypeService = storageTypeService.split(",").map(Number);
    }
    var storageMedia = localStorage.getItem("dashboard_manager_media") || [];
    if (storageMedia.length !== 0) {
      storageMedia = storageMedia.split(",").map(Number);
    }

    var storageFilterOrder =
      localStorage.getItem("managerdashboard_filter_order") ||
      "duração do status";
    var storageFilterSelec =
      localStorage.getItem("managerdashboard_filter_selec") || "Recebidas";
    var storageFilterSortname =
      localStorage.getItem("managerdashboard_filter_sortname") ||
      "qtde_recebidas";
    var storageFilterSortordername =
      localStorage.getItem("managerdashboard_filter_sortordername") || "dec";
    var storageFilterSortId =
      localStorage.getItem("managerdashboard_filter_sortid") || "";

    super(props);
    this.SearchHistoryQueue = this.SearchHistoryQueue.bind(this);
    this.state = {
      sortName: storageFilterSortname,
      ordemSort: storageFilterSortordername,
      sortSelec: storageFilterSelec,
      idSort: storageFilterSortId,
      filtroSub: [],
      buttonFilterService: false,
      buttonFilterGroup: false,
      buttonFilterSort: false,
      buttonShowChamado: true,
      buttonShowChamador: false,
      buttonShowDateFim: true,
      searchText: "",
      buttonShowMidia: false,
      buttonShowDateInit: true,
      shown: true,
      buttonShowRing: true,
      historyUser: [],
      totalRegistros: 0,
      buttonFixRegister: false,
      expandRegister: [],
      contRegister: 0,
      MidiasId: [],
      RegisterFix: [],
      senhaincorreta: "none",
      redirect: false,
      cliente: "Nenhum",
      cdrid: 0,
      sort: [{ info: "mediaid", action: true }],
      auxsort: "mediaid",
      sortActive: false,
      callqueue: [],
      auxkeyQueue: [],
      typequeue: ["0", "1", "2"],
      typemedia: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      typefilter: storageMedia,
      typeservice: storageTypeService,
      expandQueue: [],
      groups: [],
      DescAnotacoes: [],
      critSelec: "Todos",
      iconCrit: "",
      idCrit: "",
      buttonShowCriticits: false,
      detailsAnotations: [],
      totalAnotations: 0,
      detailsMarkstar: [],
      detailsFileShared: [],
      totalMarkstar: 0,
      totalFiles: 0,
      buttonLearnMore: false,
      expandLearn: [],
      optionsActionsFile: [],
      buttonShowOptionsAnot: false,
      buttonShowInsertAnot: false,
      SelecCritic: "Selecione",
      defaultValueFormat: "Todos",
      defaultValueMidias: "Todos",
      totalAnotations: 0,
      totalFiles: 0,
      totalMarkstar: 0,
      totalhistory: 0,
      nameCli: "Cliente",
      scrollEnd: 30,
      isOpen: false,
    };
    this.SearchHistory = this.SearchHistory.bind(this);
  }

  renderPopoverInfo2 = (e, info) => (
    <div className="context-menu" id="qtd-retorno">
      {(() => {
        if (info) {
          let array = info.split(";");
          array.pop();
          return (
            <ul className="context-menu__list">
              {array.map((todo) => {
                let position = todo.split("-");
                return (
                  <li className="context-menu__item">
                    <div className="container-tippy-return">
                      <div className="tippyTxt">
                        {position[2] ? position[1] : position[0]}
                      </div>

                      <div className="item-tippy-return">
                        <i className="material-icons">date_range</i>{" "}
                        {position[2] ? position[0] : ""}
                      </div>

                      <div className="info-return">
                        <span>Motivo: </span>
                        {position[2] ? position[2] : position[1]}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          );
        }
      })()}
    </div>
  );

  SearchHistory(idatendimento, telefone) {
    let histstart = document.getElementById("hist_start").value;
    let histend = document.getElementById("hist_end").value;
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(
      histstart,
      histend,
      idatendimento,
      telefone,
      idgroup
    );
  }

  ShowNameCli(numberqueue, contactname) {
    this.setState({ numberqueue: numberqueue });
    if (contactname) {
      this.setState({ nameCli: contactname });
    } else {
      this.setState({ nameCli: numberqueue });
    }
  }

  ShowModals(
    e,
    numberqueue,
    contactname,
    modal,
    cdrid,
    queueid,
    queue,
    infousers
  ) {
    this.ShowNameCli(numberqueue, contactname);
    // eslint-disable-next-line default-case
    switch (modal) {
      case "modal__anotacoes":
        MicroModal.show("modal__anotacoes_manager");
        break;
      case "modal__arquivos-compartilhados":
        MicroModal.show("modal__arquivos-compartilhados_manager");
        break;
      case "modal__mensagens-favoritas":
        MicroModal.show("modal__mensagens-favoritas_manager");
        break;
      case "modal__historico-atendimento_manager":
        this.props.ClearHistory();
        let histstart = this.datahistoryinitmanager.value;
        let histend = this.datahistoryfimmanager.value;
        if (queue.status === "1") {
          this.props.CarregamentoInteractions(cdrid, infousers.idgroup);
        } else {
          this.props.CarregamentoCDR(queueid, infousers.idgroup);
        }
        MicroModal.show("modal__historico-atendimento_manager");
        this.setState({
          clientpdf: numberqueue,
          datapdfend: histend,
          datapdfinit: histend,
          cliente: contactname,
        });
        break;
      case "modal__excluir":
        MicroModal.show("modal__excluir_manager");
        this.setState({
          deletequeueid: cdrid,
          deletecdrid: queueid,
          mediaid: queue.mediaid,
        });
        break;
    }
  }

  SearchHistoryQueue(idatendimento, telefone) {
    let histstart = this.datahistoryinitmanager.value;
    let histend = this.datahistoryfimmanager.value;
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(
      histstart,
      histend,
      33,
      this.state.numberqueue,
      idgroup
    );
    this.setState({ datapdfend: histend, datapdfinit: histend });
  }

  getFilterMedia(e, idmedia) {
    let filterstoragemedia = [];
    if (e.target.checked) {
      this.setState({
        typefilter: this.state.typefilter.concat([idmedia]),
      });
      filterstoragemedia = this.state.typefilter.concat([idmedia]);
    } else {
      this.setState({
        typefilter: this.state.typefilter.filter(function (val) {
          return val != idmedia;
        }),
      });
      filterstoragemedia = this.state.typefilter.filter(function (val) {
        return val != idmedia;
      });
    }

    localStorage.setItem("dashboard_manager_media", filterstoragemedia);
  }

  SearchInHistory(e) {
    e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  }

  buttonSearchAnotation(e) {
    e.preventDefault();
    var erro = 0;
    const datainit = this.dataInitmanager.value;
    const datafim = this.dataFimmanager.value;
    const idcriticidade = this.state.idCrit;

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsAnotationsida(
        datainit,
        datafim,
        idcriticidade,
        this.state.numberqueue
      );
    }
  }

  showExpandVisual(e, idarq) {
    var click =
      this.state.optionsActionsFile.indexOf(idarq) != -1 ? true : false;

    if (!click) {
      this.setState({
        optionsActionsFile: this.state.optionsActionsFile.concat([idarq]),
      });
    } else {
      this.setState({
        optionsActionsFile: this.state.optionsActionsFile.filter(function (
          val
        ) {
          return val != idarq;
        }),
      });
    }
  }

  buttonSearchFileCompart(e) {
    e.preventDefault();
    var erro = 0;
    const datainit = this.timearqinitmanager.value;
    const datafim = this.timearqfimmanager.value;
    const formats = this.mimetypeids.value;
    const midias = this.midias.value;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (formats == "") var erro = 1;

    if (midias == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsFileSharedIn(
        datainit,
        datafim,
        formats,
        midias,
        this.state.numberqueue
      );
    }
  }

  buttonSearchMarkstar(e) {
    e.preventDefault();
    var erro = 0;
    let datainit = this.dataInitMarkmanager.value;
    let datafim = this.dataFimMarkmanager.value;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsMarkstarida(datainit, datafim, this.state.numberqueue);
    }
  }

  renderPopoverInfo = (e, ip, file) => (
    <>
      {file ? (
        <div className="img">
          <img
            src={
              file ? connection_platform.type_connect + "://" + ip + file : null
            }
            width="100"
            alt=""
          />
        </div>
      ) : (
        ""
      )}
    </>
  );

  RefreshNoAnswer(e, cdrid, queueid, infousers) {
    this.props.PropsRefreshNoAnswer(cdrid, queueid, infousers);
    document.getElementById("simulation_click").click();
  }

  VerifierImage(e, urlimage, modal) {
    this.setState({ isOpen: true, urlimage: urlimage });
    if (modal === "history") {
      MicroModal.close("modal__historico-atendimento_manager");
    }
    if (modal === "dmark") {
      MicroModal.close("modal__mensagens-favoritas_manager");
    }
  }

  CloseImage(e, modal) {
    this.setState({ isOpen: false, urlimage: "" });
    if (modal === "history") {
      MicroModal.show("modal__historico-atendimento_manager");
    }
    if (modal === "dmark") {
      MicroModal.show("modal__mensagens-favoritas_manager");
    }
  }

  renderPopover = (
    e,
    numberqueue,
    contactname,
    cdrid,
    queueid,
    queue,
    infousers
  ) => (
    <div className="context-menu" id="info-fila">
      <ul className="context-menu__list">
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__anotacoes",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Anotações
          </a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__arquivos-compartilhados",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Arquivos compartilhados
          </a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__mensagens-favoritas",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Mensagens favoritas
          </a>
        </li>
        <li className="context-menu__item">
          <a className="context-menu__link">Mapa</a>
        </li>
        <li className="context-menu__item">
          <a
            onClick={(event) =>
              this.ShowModals(
                e,
                numberqueue,
                contactname,
                "modal__historico-atendimento_manager",
                cdrid,
                queueid,
                queue,
                infousers
              )
            }
            className="context-menu__link"
          >
            Interações
          </a>
        </li>
        {(() => {
          if (infousers.supervisor === true) {
            return (
              <>
                {" "}
                <li className="context-menu__item">
                  <a
                    className="context-menu__link"
                    onClick={(event) =>
                      this.RefreshNoAnswer(e, cdrid, queueid, infousers)
                    }
                  >
                    Atualizar para não atendida
                  </a>
                </li>
              </>
            );
          }
        })()}
      </ul>
    </div>
  );

  getFilterMediaGrupo(e, idmedia) {
    // if (e.target.checked){
    //   this.setState({
    //     typefilter: this.state.typefilter.concat([idmedia])
    //   })
    // } else {
    //   this.setState({
    //     typefilter : this.state.typefilter.filter(function(val) {return val!=idmedia})
    //   })
    // }
  }

  getFilterMediaSub(e, idgrupo, idmedia) {
    if (e.target.checked) {
      // var montagemFiltro = this.state.filtroSub[idgrupo].concat([idmedia]);
      // this.state.filtroSub[idgrupo] = montagemFiltro
    } else {
      // var montagemFiltro = this.state.filtroSub[idgrupo].filter(val => val!=idmedia);
      //this.state.filtroSub[idgrupo] = montagemFiltro
    }
  }

  DisplayFilterService(e) {
    this.setState({ buttonFilterService: !this.state.buttonFilterService });
  }

  DisplayFilterGroup(e) {
    this.setState({ buttonFilterGroup: !this.state.buttonFilterGroup });
  }

  DisplayFilterSort(e) {
    this.setState({ buttonFilterSort: !this.state.buttonFilterSort });
  }

  getFilterService(e, idsrvgroup) {
    let typeservice = [];
    if (e.target.checked) {
      this.setState({
        typeservice: this.state.typeservice.concat([idsrvgroup]),
      });
      typeservice = this.state.typeservice.concat([idsrvgroup]);
    } else {
      this.setState({
        typeservice: this.state.typeservice.filter(function (val) {
          return val != idsrvgroup;
        }),
      });
      typeservice = this.state.typeservice.filter(function (val) {
        return val != idsrvgroup;
      });
    }

    localStorage.setItem("dashboard_monitoring_typeservice", typeservice);
  }

  sortByName(event, sortName, descsort, idsort) {
    if (descsort != null) {
      this.setState({ sortSelec: descsort, idSort: idsort });
      this.setState({ buttonFilterSort: !this.state.buttonFilterSort });
      localStorage.setItem("managerdashboard_filter_selec", descsort);
      localStorage.setItem("managerdashboard_filter_sortid", idsort);
    }
    if (sortName !== "" && sortName !== null) {
      sortAtual = sortName;
      localStorage.setItem("managerdashboard_filter_sortname", sortName);
    }

    var By = document.querySelector(
      'input[name="ordenamento_sort"]:checked'
    ).value;

    if (By === "cres") {
      sort = "desc";
      localStorage.setItem("managerdashboard_filter_ordersort", sort);
      this.setState({ ordemSort: "dec" });
      localStorage.setItem("managerdashboard_filter_sortordername", "dec");
    } else {
      sort = "asc";
      localStorage.setItem("managerdashboard_filter_ordersort", sort);
      this.setState({ ordemSort: "cres" });
      localStorage.setItem("managerdashboard_filter_sortordername", "cres");
    }

    this.setState({ sortName: sortAtual });
    localStorage.setItem("managerdashboard_filter_sortname", sortAtual);
  }

  ShowCriticitys(e) {
    e.preventDefault();
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({
      critSelec: desccriticidade,
      iconCrit: tipocriticidade,
      idCrit: idcriticidade,
    });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys2(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({ SelecCritic: desccriticidade, idCrit2: idcriticidade });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  ShowChoiceFormat(e) {
    e.preventDefault();
    this.setState({ buttonShowFormatsFile: !this.state.buttonShowFormatsFile });
  }

  choiceFormat(event, formats, name) {
    this.mimetypeids.value = formats;
    this.setState({
      buttonShowFormatsFile: !this.state.buttonShowFormatsFile,
      defaultValueFormat: name,
    });
  }

  choiceMidia(event, midias, name) {
    this.midias.value = midias;
    this.setState({
      buttonShowMidias: !this.state.buttonShowMidias,
      defaultValueMidias: name,
    });
  }

  ShowChoiceMidias(e) {
    e.preventDefault();
    this.setState({ buttonShowMidias: !this.state.buttonShowMidias });
  }

  render() {
    const {
      HistoryUser,
      VerificarUser,
      listCallQueue,
      UserGroups,
      servicegroup,
      listmidias,
      filtrogrupo,
      gruposatd,
      IPCurrent,
      InfoUsers,
      StatusAgent,
      CriticidadesAnotacoes,
      PermissionRouter,
      CallBack,
      OutBandService,
      DisplayNextAtd,
      History,
      DetailsAnotations,
      DetailsMarkstar,
      DetailsFileShared,
      AtdSimult,
      FilterManager,
    } = this.props;

    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);

    this.timedefaultinitmanager = Moment().format("YYYY-MM-DDT00:00");
    this.timedefaultfimmanager = Moment().format("YYYY-MM-DDT23:59");
    this.datatimeinitmanager = Moment().format("YYYY-MM-DD");
    this.datatimefimmanager = Moment().format("YYYY-MM-DD");
    this.timearqinitmanager = Moment().format("YYYY-MM-DD");
    this.timearqfimmanager = Moment().format("YYYY-MM-DD");
    this.datainitmanager = Moment().format("YYYY-MM-DD");
    this.datafimmanager = Moment().format("YYYY-MM-DD");
    var dia = "";
    var mes = "";
    var ano = "";
    var auxdia = "";

    if (VerificarUser.length === 0) return <Redirect to="/login" />;

    if (HistoryUser.length != 0) {
      this.state.historyUser = HistoryUser.historycalls;
    }

    if (listCallQueue.length != 0) {
      this.state.callqueue = listCallQueue;

      if (this.state.typequeue != "") {
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          this.state.typequeue.includes(queue.status)
        );
      }
      if (this.state.typemedia != "") {
        this.state.callqueue = this.state.callqueue.filter((queue) =>
          this.state.typemedia.includes(queue.mediaid)
        );
      }
    } else {
      this.state.callqueue = [];
    }

    if (CriticidadesAnotacoes.length != 0) {
      this.state.DescAnotacoes = CriticidadesAnotacoes.criticalitys;
      if (this.state.idCrit2 === 0) {
        this.state.iconeCriticidade =
          this.state.DescAnotacoes[0].class_criticality;
        this.state.SelecCritic = this.state.DescAnotacoes[0].description;
        this.state.idCrit2 = this.state.DescAnotacoes[0].id;
      }
    }

    if (servicegroup.length != 0) {
      this.state.srvgroup = servicegroup;

      jsonSRV = JSON.parse(servicegroup.json);
    } else {
      this.state.srvgroup = [];
    }

    // if(listsupgroup.length != 0){
    //   this.state.lsupgroup = listsupgroup.listsupgroup;

    //    if(this.state.typeservice !=''){
    //      this.state.lsupgroup = this.state.lsupgroup.filter(lsgroup => this.state.typeservice.includes(parseInt(lsgroup.idgroupint)))
    //    }

    //  if(this.state.typefilter !=''){
    //   this.state.lsupgroup = this.state.lsupgroup.filter(lsgroup => this.state.typefilter.includes(parseInt(lsgroup.mediaid)))
    //  }

    // }else{
    //   this.state.lsupgroup = [];
    // }

    if (listmidias.length != 0) {
      this.state.lsmidias = listmidias.midiaid;
    } else {
      this.state.lsmidias = [];
    }

    if (filtrogrupo.length != 0) {
      this.state.filtrogrp = filtrogrupo.servicoagrupado.map(
        (filtro) => filtro.idgrupo
      );
    } else {
      this.state.filtrogrp = [];
    }

    if (gruposatd.length != 0) {
      this.state.lsgruposatd = gruposatd.groups;
    } else {
      this.state.lsgruposatd = [];
    }

    if (DetailsAnotations.length != 0) {
      this.state.detailsAnotations = DetailsAnotations.detailsanotations;
      this.state.totalAnotations = this.state.detailsAnotations.length;
    } else {
      this.state.detailsAnotations = [];
      this.state.totalAnotations = 0;
    }

    if (DetailsMarkstar.length != 0) {
      this.state.detailsMarkstar = DetailsMarkstar.detailsmarkstars;
      this.state.totalMarkstar = this.state.detailsMarkstar.length;
    } else {
      this.state.detailsMarkstar = [];
      this.state.totalMarkstar = 0;
    }

    if (DetailsFileShared.length != 0) {
      this.state.detailsFileShared = DetailsFileShared.detailsfileshared;
      this.state.totalFiles = this.state.detailsFileShared.length;
    } else {
      this.state.detailsFileShared = [];
      this.state.totalFiles = 0;
    }

    if (History.length) {
      this.state.history = History;
      let testarultimo = 0;
      var total = this.state.history[0];
      this.state.totalhistory = total.interacoes;
    } else {
      this.state.history = [];
    }

    if (UserGroups.length != 0) {
      this.state.groups = UserGroups.groups;
    }

    const list = this.state.callqueue || [];

    this.state.callqueue = _.filter(list, (queue) => {
      let arrayQueue = [
        queue.caller,
        queue.called,
        queue.to_char,
        queue.recv_count,
      ];
      return !_.isEmpty(this.state.filterQueue)
        ? arrayQueue
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterQueue.toString().toLowerCase()) > -1
        : true;
    });

    let desempenhoMAXTME = 0;
    let desempenhoTmpFila = 0;
    let desempenhoqtdFila = 0;
    let desempenhoTmpABDN = 0;
    let desempenhonsservico = 0;
    let resultadoTMA = 0;
    let desempenhoTmpAtd = 0;
    let resultadoTMABN = 0;
    let desempenhoRec = 0;
    let desempenhoAtd = 0;
    let desempenhoAtdOutSLA = 0;
    let desempenhoAbdn = 0;
    let desempenhoCurtas = 0;
    let desempenhoTransf = 0;
    let resultadoTMEA = 0;
    let resultadoMTEA = 0;
    let desempenhoTotalFila = 0;
    let arrayFiltro = [];
    let filtroSub = [];
    let maxcallqueue = 0;
    let cdrmaxcallqueue = 0;
    let cdridatual = 0;
    let timeatual = 0;
    let timeQueue = 0;
    let maxcallqueueDate = 0;
    let duracao = 0;
    let pathFile = 0;
    let queueMediaid = 0;
    let queueContactname = 0;
    let queueCaller = 0;
    let queueQueueid = 0;
    let queueScriptid = 0;
    let queueCdrid = 0;
    let queueGeral = 0;
    let queueCalled = 0;
    let queueRecv_count = 0;
    let queueObs = 0;
    let queueCallback_count = 0;
    let maxcallqueueFormat = 0;
    let valorNSFinal = 0;
    let desempenhoTotalFilaSub = [];

    let maxcallqueueSub = [];
    let maxcallqueueFormatSub = [];
    let cdrmaxcallqueueSub = [];
    let pathFileSub = [];
    let queueMediaidSub = [];
    let queueContactnameSub = [];
    let queueCallerSub = [];
    let queueQueueidSub = [];
    let queueScriptidSub = [];
    let queueCdridSub = [];
    let queueGeralSub = [];
    let queueCalledSub = [];
    let queueRecv_countSub = [];
    let queueObsSub = [];
    let queueCallback_countSub = [];
    let uniqueGroup = [];
    let grupoAnterior = 0;

    if (this.props.screen === "new") {
      if (FilterManager.is_active) {
        this.state.typeservice = FilterManager.filter_manager_service;
        this.state.typefilter = FilterManager.filter_manager_channel;
      }
    }

    return (
      <div className="column-model--overflow w-auto">
        <div className="column-model__body">
          <div className="column-model__body__block">
            <div
              className="box"
              style={{ display: this.props.screen === "new" ? "none" : "flex" }}
            >
              <div className="box__title">Filtros</div>
              <div className="box__body">
                <div className="card card--small ">
                  <div className="sp-bw">
                    <div className="card__title">Serviço:</div>
                    <div
                      className={
                        this.state.buttonFilterService
                          ? "select with-icons active"
                          : "select with-icons"
                      }
                    >
                      <button
                        className="select__btn"
                        type="button"
                        onClick={(event) => this.DisplayFilterService(event)}
                      >
                        Filtros
                        <i className="select__icon material-icons">
                          keyboard_arrow_right
                        </i>
                      </button>
                      <div className="options">
                        <ul>
                          {(() => {
                            Object.keys(jsonSRV).filter((key) => {
                              if (jsonSRV[key].idgrupo !== grupoAnterior) {
                                grupoAnterior = jsonSRV[key].idgrupo;
                                uniqueGroup.push(jsonSRV[key]);
                              }
                            });
                          })()}

                          {uniqueGroup
                            .filter(
                              (key) =>
                                this.state.filtrogrp.includes(key.idgrupo) //[{"descgrupo: "Suporte Voz",idgrupo: 1"},{"descgrupo: "Whatsapp",idgrupo: 5"}]
                            )
                            .map((group) =>
                              (() => {
                                return (
                                  <li key={keycount++}>
                                    <input
                                      type="checkbox"
                                      name="inputsrvgroup"
                                      id="inputsrvgroup"
                                      defaultChecked={
                                        this.state.typeservice.findIndex(
                                          function (val) {
                                            return val === group.idgrupo;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterService(
                                          event,
                                          group.idgrupo
                                        )
                                      }
                                    />
                                    <label htmlFor="inputsrvgroup">
                                      {group.nomegrupo}
                                    </label>
                                  </li>
                                );
                              })()
                            )}
                        </ul>
                        <a
                          className="btn btn-primary"
                          id="apply-filters"
                          onClick={(event) => this.DisplayFilterService(event)}
                        >
                          Fechar
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card card--small ">
                  <div className="sp-bw">
                    <div className="">
                      <div className="card__title">Canais:</div>
                      <div className="card__text card__text--small">
                        Toque nos ícones
                      </div>
                    </div>
                    <div className="checkbox">
                      <div className="checkbox__row inline">
                        {this.state.lsmidias.map((midias) =>
                          (() => {
                            switch (parseInt(midias.midiaid)) {
                              case 1:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="voz-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 1;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 1)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="voz-geral"
                                    >
                                      <img
                                        width="22"
                                        src={PHONENEW}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="Voz"
                                      />
                                    </label>
                                  </div>
                                );
                              case 2:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="webchat-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 2;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 2)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="webchat-geral"
                                    >
                                      <img
                                        width="22"
                                        src={WEBCHATNEW}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="Webchat"
                                      />
                                    </label>
                                  </div>
                                );
                              case 3:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="email-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 3;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 3)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="email-geral"
                                    >
                                      <img
                                        width="22"
                                        src={MIDIAEMAIL}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="email"
                                      />
                                    </label>
                                  </div>
                                );

                              case 4:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="facebook-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 4;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 4)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="facebook-geral"
                                    >
                                      <img
                                        width="22"
                                        src={FACEBOOKNEW}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="facebook"
                                      />
                                    </label>
                                  </div>
                                );
                              case 5:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="whatsapp-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 5;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 5)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="whatsapp-geral"
                                    >
                                      <img
                                        width="22"
                                        src={WHATSAPPNEW}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="Whatsapp"
                                      />
                                    </label>
                                  </div>
                                );

                              case 6:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="instagram-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 6;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 6)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="instagram-geral"
                                    >
                                      <img
                                        width="22"
                                        src={INSTAGRAM}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="instagram"
                                      />
                                    </label>
                                  </div>
                                );
                              case 8:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="telegram-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 8;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 8)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="telegram-geral"
                                    >
                                      <img
                                        width="22"
                                        src={MIDIATELEGRAM}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="telegram"
                                      />
                                    </label>
                                  </div>
                                );
                              case 9:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="twitter-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 9;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 9)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="twitter-geral"
                                    >
                                      <img
                                        width="22"
                                        src={TWITTER}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="twitter"
                                      />
                                    </label>
                                  </div>
                                );
                              case 10:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="linkedin-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 10;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 10)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="linkedin-geral"
                                    >
                                      <img
                                        width="22"
                                        src={LINKEDIN}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="linkedin"
                                      />
                                    </label>
                                  </div>
                                );
                              case 11:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="googlegbm-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 11;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 11)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="googlegbm-geral"
                                    >
                                      <img
                                        width="22"
                                        src={GOOGLEGBM}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="googlegbm"
                                      />
                                    </label>
                                  </div>
                                );
                              case 15:
                                return (
                                  <div
                                    className="checkbox__row__input-icon-box"
                                    key={keycount++}
                                  >
                                    <input
                                      type="checkbox"
                                      name="midia-check"
                                      id="teams-geral"
                                      defaultChecked={
                                        this.state.typefilter.findIndex(
                                          function (val) {
                                            return val === 15;
                                          }
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        this.getFilterMedia(event, 15)
                                      }
                                    />
                                    <label
                                      className="checkbox__row__input-icon-box__label"
                                      htmlFor="teams-geral"
                                    >
                                      <img
                                        width="22"
                                        src={TEAMS}
                                        alt=""
                                        className="tippy-default"
                                        data-tippy-content="teams"
                                      />
                                    </label>
                                  </div>
                                );
                            }
                          })()
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card card--small">
                  <div className="sp-bw">
                    <div className="card__title">Ordenar:</div>
                    <div className="checkbox checkbox__with-separator">
                      <div className="checkbox__row inline">
                        <div className="checkbox__row__input-icon-box">
                          <input
                            type="radio"
                            name="ordenamento_sort"
                            id="ordenar-cres"
                            defaultChecked={
                              this.state.ordemSort === "cres" ? false : true
                            }
                            value="cres"
                            onClick={(event) =>
                              this.sortByName(event, null, null, null)
                            }
                          />
                          <label
                            className="checkbox__row__input-icon-box__label"
                            htmlFor="ordenar-cres"
                          >
                            <i
                              className="material-icons tippy-default"
                              data-tippy-content="Crescente"
                              tabIndex="0"
                            >
                              arrow_upward
                            </i>
                          </label>
                        </div>

                        <div className="checkbox__row__input-icon-box">
                          <input
                            type="radio"
                            name="ordenamento_sort"
                            id="ordenar-dec"
                            defaultChecked={
                              this.state.ordemSort === "dec" ? false : true
                            }
                            value="dec"
                            onClick={(event) =>
                              this.sortByName(event, null, null, null)
                            }
                          />
                          <label
                            className="checkbox__row__input-icon-box__label"
                            htmlFor="ordenar-dec"
                          >
                            <i
                              className="material-icons tippy-default"
                              data-tippy-content="Decrescente"
                              tabIndex="0"
                            >
                              arrow_downward
                            </i>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        this.state.buttonFilterSort
                          ? "select with-icons active"
                          : "select with-icons"
                      }
                    >
                      <button
                        className="select__btn"
                        type="button"
                        data-pausa="Ordenamento"
                        onClick={(event) => this.DisplayFilterSort(event)}
                      >
                        {this.state.sortSelec}
                        <i className="select__icon material-icons">
                          keyboard_arrow_left
                        </i>
                      </button>

                      <div className="options ">
                        <ul>
                          <li
                            key={1}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "qtde_recebidas",
                                "Recebidas",
                                1
                              )
                            }
                          >
                            <label htmlFor="filter1">Recebidas</label>
                          </li>
                          <li
                            key={2}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "qtde_atendidas",
                                "Atendidas",
                                2
                              )
                            }
                          >
                            <label htmlFor="filter2">Atendidas</label>
                          </li>
                          <li
                            key={3}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "qtde_abandonada",
                                "Abandonadas",
                                3
                              )
                            }
                          >
                            <label htmlFor="filter3">Abandonadas</label>
                          </li>
                          <li
                            key={4}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "tmatendida",
                                "Tempo médio de atendimento",
                                4
                              )
                            }
                          >
                            <label htmlFor="filter4">
                              Tempo médio de atendimento
                            </label>
                          </li>
                          <li
                            key={5}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "tmabandonada",
                                "Tempo médio de abandono",
                                5
                              )
                            }
                          >
                            <label htmlFor="filter5">
                              Tempo médio de abandono
                            </label>
                          </li>
                          <li
                            key={6}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "tmespera",
                                "Tempo médio de espera para atendimento",
                                6
                              )
                            }
                          >
                            <label htmlFor="filter6">
                              Tempo médio de espera para atendimento
                            </label>
                          </li>
                          <li
                            key={7}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "duracao_maxima_fila",
                                "Maior tempo de espera para atendimento",
                                7
                              )
                            }
                          >
                            <label htmlFor="filter7">
                              Maior tempo de espera para atendimento
                            </label>
                          </li>
                          <li
                            key={8}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "qtde_transferida",
                                "Transferidas",
                                8
                              )
                            }
                          >
                            <label htmlFor="filter8">Transferidas</label>
                          </li>
                          {/* <li key={9} onClick={event => this.sortByName(event, 'totalfila','Clientes em fila',9)}><label htmlFor="filter9">Clientes em fila</label></li>*/}
                          <li
                            key={10}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "percentual_atendida",
                                "% Atendidas",
                                10
                              )
                            }
                          >
                            <label htmlFor="filter10">% Atendidas</label>
                          </li>
                          <li
                            key={11}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "percentual_abandonada",
                                "% Abandono",
                                11
                              )
                            }
                          >
                            <label htmlFor="filter11">% Abandono</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {(() => {
              if (jsonSRV.length > 0) {
                return (
                  <div className="box">
                    <div className="box__title box__title--light">
                      Total dos Serviços
                    </div>

                    <div className="box__body">
                      {() => {
                        desempenhoRec = 0;
                        desempenhoAtd = 0;
                        desempenhoAtdOutSLA = 0;
                        desempenhoAbdn = 0;
                        desempenhoCurtas = 0;
                        desempenhoTmpAtd = 0;
                        desempenhoTmpABDN = 0;
                        desempenhoTmpFila = 0;
                        desempenhoqtdFila = 0;
                        desempenhoTransf = 0;
                        desempenhoMAXTME = 0;
                        desempenhoTotalFila = 0;
                        //desempenhonsservico  = 0;
                      }}

                      {Object.keys(jsonSRV)
                        .filter(
                          (group2) =>
                            this.state.typeservice.includes(
                              jsonSRV[group2].idgrupo
                            ) &&
                            this.state.typefilter.includes(
                              jsonSRV[group2].idmidia
                            )
                          // &&
                          // this.state.filtrogrp.includes(jsonSRV[group2].idgrupo)
                        )

                        .map((group) =>
                          (() => {
                            desempenhoRec += jsonSRV[group].qtde_recebidas;
                            desempenhoAtd += jsonSRV[group].qtde_atendidas;
                            desempenhoCurtas +=
                              jsonSRV[group].qtde_abandonada_sla;
                            desempenhoAtdOutSLA +=
                              jsonSRV[group].qtde_atendida_fora_sla;
                            desempenhoAbdn += jsonSRV[group].qtde_abandonada;
                            desempenhoTmpAtd +=
                              jsonSRV[group].duracao_atendidas;
                            desempenhoTmpABDN +=
                              jsonSRV[group].duracao_abandonada_fila;
                            desempenhoTmpFila += jsonSRV[group].duracao_fila;
                            desempenhoqtdFila += jsonSRV[group].qtde_fila_atd;
                            desempenhoTransf += jsonSRV[group].qtde_transferida;
                            desempenhonsservico = jsonSRV[group].percentual_ns;

                            if (
                              jsonSRV[group].duracao_maxima_fila >
                              desempenhoMAXTME
                            )
                              desempenhoMAXTME =
                                jsonSRV[group].duracao_maxima_fila;

                            //  if(listCallQueue.length != 0){
                            //   desempenhoTotalFila = this.state.callqueue.filter(
                            //       queue => parseInt(queue.status) === 1

                            //     )

                            //   }

                            this.state.callqueue.map((queue) =>
                              (() => {
                                if (parseInt(queue.status) === 1) {
                                  Object.keys(jsonSRV[group].subservico)
                                    .filter(
                                      (key) =>
                                        this.state.typeservice.includes(
                                          jsonSRV[group].idgrupo
                                        ) &&
                                        this.state.typefilter.includes(
                                          jsonSRV[group].idmidia
                                        ) &&
                                        this.state.filtrogrp.includes(
                                          jsonSRV[group].idgrupo
                                        )
                                    )
                                    .map((idsubservico) =>
                                      (() => {
                                        if (
                                          parseInt(queue.status) === 1 &&
                                          parseInt(
                                            jsonSRV[group].subservico[
                                              idsubservico
                                            ]
                                          ) === parseInt(queue.serviceinid) &&
                                          jsonSRV[group].idmidia ===
                                            queue.mediaid
                                        ) {
                                          //if(parseInt(queue.status) === 1 && parseInt(jsonSRV[group].subservico[idsubservico]) === parseInt(queue.serviceinid)){
                                          desempenhoTotalFila++;
                                        }
                                      })()
                                    );
                                }
                              })()
                            );
                          })()
                        )}

                      {(() => {
                        // let valorNSFinal = desempenhoAtd > 0 ?  ((((parseInt(desempenhoAtd)-parseInt(desempenhoAtdOutSLA))/((parseInt(desempenhoRec))-(desempenhoCurtas)))/(desempenhonsservico).toFixed(2))*100) : 0).toFixed(2)

                        valorNSFinal =
                          desempenhoAtd > 0
                            ? ((parseInt(desempenhoAtd) -
                                parseInt(desempenhoAtdOutSLA)) /
                                (parseInt(desempenhoRec) -
                                  parseInt(desempenhoCurtas)) /
                                desempenhonsservico) *
                              100
                            : 0;

                        if (valorNSFinal > 100) valorNSFinal = 100;
                      })()}

                      <div className="progress">
                        <div
                          className="progress-bar"
                          id="progress-1"
                          style={{ width: valorNSFinal.toFixed(2) + "%" }}
                        ></div>

                        <div className="title">
                          <div className="title__text">Nível de serviço:</div>
                          <div className="title__number">
                            {valorNSFinal.toFixed(2)}%
                          </div>
                        </div>
                      </div>

                      {this.state.callqueue.map((queue) =>
                        (() => {
                          if (parseInt(queue.status) === 1) {
                            let checkMidiaSelecionada = false;

                            for (
                              var i = 0;
                              i < this.state.typefilter.length;
                              i++
                            ) {
                              if (
                                parseInt(this.state.typefilter[i]) ===
                                parseInt(queue.mediaid)
                              ) {
                                checkMidiaSelecionada = true;
                              }
                            }

                            if (
                              checkMidiaSelecionada === true ||
                              this.state.typefilter.length <= 0
                            ) {
                              if (
                                Moment(
                                  queue.to_char,
                                  "DD/MM/YYYY HH:mm:ss"
                                ).format("DD/MM/YYYY HH:mm:ss") <
                                  maxcallqueue ||
                                maxcallqueue === 0
                              ) {
                                maxcallqueue = Moment(
                                  queue.to_char,
                                  "DD/MM/YYYY HH:mm:ss"
                                ).format("DD/MM/YYYY HH:mm:ss");
                                maxcallqueueFormat = Moment(
                                  queue.to_char,
                                  "DD/MM/YYYY HH:mm:ss"
                                ).format("YYYY/MM/DD HH:mm:ss");
                                cdrmaxcallqueue = queue.cdrid;
                                pathFile = queue.pathfile;
                                queueMediaid = queue.mediaid;
                                queueContactname = queue.contactname;
                                queueCaller = queue.caller;
                                queueQueueid = queue.queueid;
                                queueScriptid = queue.scriptid;
                                queueCdrid = queue.cdrid;
                                queueGeral = queue;
                                queueCalled = queue.called;
                                queueRecv_count = queue.recv_count;
                                queueObs = queue.obs;
                                queueCallback_count = queue.callback_count;
                              }
                            }
                          }
                        })()
                      )}

                      {(() => {
                        if (desempenhoTotalFila > 0) {
                          return (
                            <div
                              className="card card--column"
                              key="#99999999_999999"
                            >
                              <div className="card__number card__number--small bold">
                                Cliente com maior tempo de fila:
                              </div>

                              <div className="item">
                                <div className="img">
                                  {(() => {
                                    if (
                                      pathFile === "  " ||
                                      pathFile === " " ||
                                      pathFile === null
                                    ) {
                                      return <img src={DEFAULT} alt="" />;
                                    } else {
                                      return (
                                        <Topover
                                          interactive={true}
                                          content={this.renderPopoverInfo(
                                            this,
                                            IPCurrent.ip,
                                            pathFile
                                          )}
                                        >
                                          <img
                                            src={
                                              pathFile
                                                ? connection_platform.type_connect +
                                                  "://" +
                                                  ipcurrent +
                                                  pathFile
                                                : null
                                            }
                                            alt=""
                                          />
                                        </Topover>
                                      );
                                    }
                                  })()}
                                </div>
                                <div className="inner">
                                  <div className="about-user">
                                    <div className="nome is-poppins">
                                      {(() => {
                                        // eslint-disable-next-line default-case
                                        switch (parseInt(queueMediaid)) {
                                          case 1:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={PHONENEW}
                                                alt=""
                                              />
                                            );
                                          case 2:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={WEBCHATNEW}
                                                alt=""
                                              />
                                            );
                                          case 3:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={MIDIAEMAIL}
                                                alt=""
                                              />
                                            );
                                          case 4:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={FACEBOOKNEW}
                                                alt=""
                                              />
                                            );
                                          case 5:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={WHATSAPPNEW}
                                                alt=""
                                              />
                                            );
                                          case 6:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={INSTAGRAM}
                                                alt=""
                                              />
                                            );
                                          case 8:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={MIDIATELEGRAM}
                                                alt=""
                                              />
                                            );
                                          case 9:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={TWITTER}
                                                alt=""
                                              />
                                            );
                                          case 10:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={LINKEDIN}
                                                alt=""
                                              />
                                            );
                                          case 11:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={GOOGLEGBM}
                                                alt=""
                                              />
                                            );
                                          case 15:
                                            return (
                                              <img
                                                className="prox-atend__enqueued-icon"
                                                src={TEAMS}
                                                alt=""
                                              />
                                            );
                                          default:
                                            return <></>;
                                        }
                                      })()}

                                      <span className="nome__text is-poppins">
                                        {queueContactname !== " "
                                          ? createJSON(queueContactname)
                                          : queueCaller}
                                      </span>
                                    </div>
                                    <div
                                      className="criticidade normal"
                                      data-tippy="Normal"
                                      tabIndex="0"
                                    >
                                      •
                                    </div>
                                  </div>

                                  <div className="title">
                                    <div className="title__top">
                                      {(() => {
                                        var now;
                                        var antes;
                                        var duracao = 0;
                                        var checkItem = false;

                                        if (IPCurrent.difftime < 0) {
                                          antes = maxcallqueueFormat;
                                          now = Moment()
                                            .add(
                                              Math.round(IPCurrent.difftime),
                                              "seconds"
                                            )
                                            .format("YYYY/MM/DD HH:mm:ss");
                                          duracao = Moment(now).diff(
                                            antes,
                                            "seconds"
                                          );
                                          checkItem = true;
                                        } else {
                                          antes = maxcallqueueFormat;
                                          now = Moment()
                                            .subtract(
                                              Math.round(IPCurrent.difftime),
                                              "seconds"
                                            )
                                            .format("YYYY/MM/DD HH:mm:ss");
                                          duracao = Moment(now).diff(
                                            antes,
                                            "seconds"
                                          );
                                          checkItem = true;
                                        }

                                        return (
                                          <div className="user-time active">
                                            <i className="material-icons">
                                              query_builder
                                            </i>{" "}
                                            <span className="time">
                                              <TimeCounterMinute
                                                horario={
                                                  duracao < 0
                                                    ? 0
                                                    : parseInt(duracao)
                                                }
                                                key={queueQueueid}
                                              />{" "}
                                            </span>
                                          </div>
                                        );
                                      })()}
                                      <div className="actions">
                                        <a
                                          className="phone"
                                          onClick={() =>
                                            this.props.SolicitarChamada(
                                              InfoUsers,
                                              queueScriptid,
                                              queueCdrid,
                                              queueMediaid,
                                              StatusAgent.status,
                                              IPCurrent
                                            )
                                          }
                                          data-tippy="Atender chamada"
                                        >
                                          <i className="material-icons">call</i>
                                        </a>
                                        &nbsp;
                                        <Popover
                                          trigger="click"
                                          boundary="window"
                                          placement="right"
                                          multiple={true}
                                          interactive={true}
                                          content={this.renderPopover(
                                            this,
                                            queueCaller,
                                            queueContactname,
                                            queueCdrid,
                                            queueQueueid,
                                            queueGeral,
                                            InfoUsers
                                          )}
                                        >
                                          <a
                                            className="info tippy-context-menu"
                                            data-tooltip="Mais informações"
                                            data-template="info-fila"
                                          >
                                            <i className="material-icons">
                                              info
                                            </i>
                                          </a>
                                        </Popover>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="details active">
                                    <div className="item details__text">
                                      <i className="material-icons">
                                        smartphone
                                      </i>{" "}
                                      {queueCaller}
                                    </div>
                                    <div className="item pct100  details__text">
                                      <i className="material-icons">
                                        report_problem
                                      </i>{" "}
                                      {queueCalled}
                                    </div>
                                    <div className="item pct100  details__text">
                                      <i className="material-icons">
                                        settings_phone
                                      </i>{" "}
                                      Qtde. de tentativas:{" "}
                                      <span>{queueRecv_count}</span>
                                    </div>
                                    <Topover
                                      interactive={true}
                                      boundary="window"
                                      placement="left"
                                      content={this.renderPopoverInfo2(
                                        this,
                                        queueObs
                                      )}
                                    >
                                      <div
                                        className="item pct100  details__text qtd-retorno tippy-context-menu"
                                        data-tippy-placement="right"
                                        data-template="qtd-retorno"
                                      >
                                        <i className="material-icons">
                                          phone_callback
                                        </i>{" "}
                                        Qtde. de retorno:{" "}
                                        <span className="details__text-qtd">
                                          {" "}
                                          {queueCallback_count}
                                        </span>
                                      </div>
                                    </Topover>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })()}

                      <div className="box__body sec">
                        <div className="card card--op card--justify">
                          <div className="card__number card__number--op">
                            {desempenhoTotalFila} clientes em fila
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Clientes recebidos:
                            </div>
                            <div className="card__number">
                              {desempenhoRec} clientes
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Clientes atendidos:
                              <div className="card__number">
                                {desempenhoRec > 0
                                  ? (
                                      (desempenhoAtd / desempenhoRec) *
                                      100
                                    ).toFixed(2)
                                  : 0}
                                %
                              </div>
                            </div>
                            <div className="card__title">
                              {desempenhoAtd} Clientes
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Tempo médio de atendimento:
                            </div>
                            <div className="card__number">
                              {TimeFormat.fromS(
                                desempenhoTmpAtd > 0
                                  ? parseInt(
                                      parseInt(desempenhoTmpAtd) /
                                        parseInt(desempenhoAtd)
                                    )
                                  : 0,
                                "hh:mm:ss"
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Clientes abandonados:
                              <div className="card__number">
                                {desempenhoRec > 0
                                  ? (
                                      (desempenhoAbdn / desempenhoRec) *
                                      100
                                    ).toFixed(2)
                                  : 0}
                                %
                              </div>
                            </div>
                            <div className="card__title">
                              {desempenhoAbdn} Clientes
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Tempo médio de abandono:
                            </div>
                            <div className="card__number">
                              {TimeFormat.fromS(
                                desempenhoTmpABDN > 0
                                  ? parseInt(
                                      parseInt(desempenhoTmpABDN) /
                                        parseInt(desempenhoAbdn)
                                    )
                                  : 0,
                                "hh:mm:ss"
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Tempo médio de espera para atendimento:
                            </div>
                            <div className="card__number">
                              {TimeFormat.fromS(
                                desempenhoTmpFila > 0
                                  ? parseInt(
                                      parseInt(desempenhoTmpFila) /
                                        parseInt(desempenhoqtdFila)
                                    )
                                  : 0,
                                "hh:mm:ss"
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Maior tempo de espera para atendimento:
                            </div>
                            <div className="card__number">
                              {TimeFormat.fromS(
                                desempenhoMAXTME > 0
                                  ? parseInt(desempenhoMAXTME)
                                  : 0,
                                "hh:mm:ss"
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div className="">
                            <div className="card__text">
                              Clientes transferidos:
                            </div>
                            <div className="card__number">
                              {desempenhoTransf} clientes
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            })()}

            {Object.keys(jsonSRV)
              .filter(
                (key) =>
                  this.state.typeservice.includes(jsonSRV[key].idgrupo) &&
                  this.state.typefilter.includes(jsonSRV[key].idmidia) &&
                  this.state.filtrogrp.includes(jsonSRV[key].idgrupo)
              )
              .sort((a, b) =>
                sort === "asc"
                  ? jsonSRV[a][sortAtual] - jsonSRV[b][sortAtual]
                  : jsonSRV[b][sortAtual] - jsonSRV[a][sortAtual]
              )
              .map((group) => (
                <div className="box" key={keycount++}>
                  <div className="box__title box__title--light">
                    {jsonSRV[group].nomegrupo}

                    <div
                      className="checkbox"
                      style={{ pointerEvents: "none", cursor: "none" }}
                    >
                      <div className="checkbox__row inline">
                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 1) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"voz-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,1)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"voz-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={"voz-" + jsonSRV[group].idgrupo}
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={PHONENEW}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="Voz"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 2) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id="webchat-1" defaultChecked  onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,2)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id="webchat-1"
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor="webchat-1"
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={WEBCHATNEW}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="Webchat"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}
                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 4) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id="facebook-1" defaultChecked  onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,4)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id="facebook-1"
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor="facebook-1"
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={FACEBOOKNEW}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="facebook"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 5) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"whatsapp-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,5)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"whatsapp-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={"whatsapp-" + jsonSRV[group].idgrupo}
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={WHATSAPPNEW}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="Whatsapp"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 9) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"twitter-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,9)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"twitter-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={"twitter-" + jsonSRV[group].idgrupo}
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={TWITTER}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="twitter"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 3) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"email-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,3)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"email-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={"email-" + jsonSRV[group].idgrupo}
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={MIDIAEMAIL}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="email"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 8) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"telegram-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,8)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"telegram-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={"telegram-" + jsonSRV[group].idgrupo}
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={MIDIATELEGRAM}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="telegram"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 10) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"linkedin-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,10)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"linkedin-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={"linkedin-" + jsonSRV[group].idgrupo}
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={LINKEDIN}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="linkedin"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 6) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"instagram-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,6)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"instagram-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={
                                    "instagram-" + jsonSRV[group].idgrupo
                                  }
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={INSTAGRAM}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="instagram"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 11) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                {/* <input type="checkbox" name="midia-check" id={"instagram-"+jsonSRV[group].idgrupo} defaultChecked onChange={event => this.getFilterMediaSub(event,jsonSRV[group].idgrupo,6)}/> */}
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"googlegbm-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={
                                    "googlegbm-" + jsonSRV[group].idgrupo
                                  }
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={GOOGLEGBM}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="googlegbm"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}

                        {(() => {
                          if (parseInt(jsonSRV[group].idmidia) === 15) {
                            return (
                              <div
                                className="checkbox__row__input-icon-box"
                                style={{
                                  pointerEvents: "none",
                                  cursor: "none",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  name="midia-check"
                                  id={"teams-" + jsonSRV[group].idgrupo}
                                  defaultChecked
                                />
                                <label
                                  className="checkbox__row__input-icon-box__label"
                                  htmlFor={"teams-" + jsonSRV[group].idgrupo}
                                >
                                  <img
                                    width="20"
                                    height="20"
                                    src={TEAMS}
                                    alt=""
                                    className="tippy-default"
                                    data-tippy-content="teams"
                                  />
                                </label>
                              </div>
                            );
                          }
                        })()}
                      </div>
                    </div>
                  </div>
                  <div className="box__body">
                    {(() => {
                      desempenhoTotalFilaSub[jsonSRV[group].idgrupo] = [];
                      maxcallqueueSub[jsonSRV[group].idgrupo] = [];
                      maxcallqueueFormatSub[jsonSRV[group].idgrupo] = [];
                      cdrmaxcallqueueSub[jsonSRV[group].idgrupo] = [];
                      pathFileSub[jsonSRV[group].idgrupo] = [];
                      queueMediaidSub[jsonSRV[group].idgrupo] = [];
                      queueContactnameSub[jsonSRV[group].idgrupo] = [];
                      queueCallerSub[jsonSRV[group].idgrupo] = [];
                      queueQueueidSub[jsonSRV[group].idgrupo] = [];
                      queueScriptidSub[jsonSRV[group].idgrupo] = [];
                      queueCdridSub[jsonSRV[group].idgrupo] = [];
                      queueGeralSub[jsonSRV[group].idgrupo] = [];
                      queueCalledSub[jsonSRV[group].idgrupo] = [];
                      queueRecv_countSub[jsonSRV[group].idgrupo] = [];
                      queueObsSub[jsonSRV[group].idgrupo] = [];
                      queueCallback_countSub[jsonSRV[group].idgrupo] = [];

                      desempenhoTotalFilaSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      maxcallqueueSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      maxcallqueueFormatSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      cdrmaxcallqueueSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      pathFileSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueMediaidSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueContactnameSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueCallerSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueQueueidSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueScriptidSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueCdridSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueGeralSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueCalledSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueRecv_countSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueObsSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                      queueCallback_countSub[jsonSRV[group].idgrupo][
                        jsonSRV[group].idmidia
                      ] = [];
                    })()}

                    {this.state.callqueue.map((queue) =>
                      (() => {
                        if (parseInt(queue.status) === 1) {
                          let checkMidiaSelecionada = false;

                          for (
                            var i = 0;
                            i < this.state.typefilter.length;
                            i++
                          ) {
                            if (
                              parseInt(this.state.typefilter[i]) ===
                              parseInt(queue.mediaid)
                            ) {
                              checkMidiaSelecionada = true;
                            }
                          }

                          Object.keys(jsonSRV[group].subservico).map(
                            (idsubservico) =>
                              (() => {
                                if (
                                  parseInt(queue.status) === 1 &&
                                  parseInt(
                                    jsonSRV[group].subservico[idsubservico]
                                  ) === parseInt(queue.serviceinid) &&
                                  jsonSRV[group].idmidia === queue.mediaid
                                ) {
                                  desempenhoTotalFilaSub[
                                    jsonSRV[group].idgrupo
                                  ][jsonSRV[group].idmidia]++;

                                  if (
                                    checkMidiaSelecionada === true ||
                                    this.state.typefilter.length <= 0
                                  ) {
                                    if (
                                      Moment(
                                        queue.to_char,
                                        "DD/MM/YYYY HH:mm:ss"
                                      ).format("DD/MM/YYYY HH:mm:ss") <
                                        maxcallqueueSub[jsonSRV[group].idgrupo][
                                          jsonSRV[group].idmidia
                                        ] ||
                                      maxcallqueueSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ].length <= 0
                                    ) {
                                      maxcallqueueSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = Moment(
                                        queue.to_char,
                                        "DD/MM/YYYY HH:mm:ss"
                                      ).format("DD/MM/YYYY HH:mm:ss");
                                      maxcallqueueFormatSub[
                                        jsonSRV[group].idgrupo
                                      ][jsonSRV[group].idmidia] = Moment(
                                        queue.to_char,
                                        "DD/MM/YYYY HH:mm:ss"
                                      ).format("YYYY/MM/DD HH:mm:ss");
                                      cdrmaxcallqueueSub[
                                        jsonSRV[group].idgrupo
                                      ][jsonSRV[group].idmidia] = queue.cdrid;
                                      pathFileSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.pathfile;
                                      queueMediaidSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.mediaid;
                                      queueContactnameSub[
                                        jsonSRV[group].idgrupo
                                      ][jsonSRV[group].idmidia] =
                                        queue.contactname;
                                      queueCallerSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.caller;
                                      queueQueueidSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.queueid;
                                      queueScriptidSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.scriptid;
                                      queueCdridSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.cdrid;
                                      queueGeralSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue;
                                      queueCalledSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.called;
                                      queueRecv_countSub[
                                        jsonSRV[group].idgrupo
                                      ][jsonSRV[group].idmidia] =
                                        queue.recv_count;
                                      queueObsSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ] = queue.obs;
                                      queueCallback_countSub[
                                        jsonSRV[group].idgrupo
                                      ][jsonSRV[group].idmidia] =
                                        queue.callback_count;
                                    }
                                  }
                                }
                              })()
                          );
                        }
                      })()
                    )}

                    {(() => {
                      if (
                        maxcallqueueSub[jsonSRV[group].idgrupo][
                          jsonSRV[group].idmidia
                        ].length > 0
                      ) {
                        return (
                          <div
                            className="card card--column"
                            key={"mtf" + jsonSRV[group].idgrupo}
                            id={"mtf" + jsonSRV[group].idgrupo}
                          >
                            <div className="card__number card__number--small bold">
                              Cliente com maior tempo de fila:
                            </div>

                            <div className="item">
                              <div className="img">
                                {(() => {
                                  if (
                                    pathFileSub[jsonSRV[group].idgrupo][
                                      jsonSRV[group].idmidia
                                    ] === "  " ||
                                    pathFileSub[jsonSRV[group].idgrupo][
                                      jsonSRV[group].idmidia
                                    ] === " " ||
                                    pathFileSub[jsonSRV[group].idgrupo][
                                      jsonSRV[group].idmidia
                                    ] === null
                                  ) {
                                    return <img src={DEFAULT} alt="" />;
                                  } else {
                                    return (
                                      <Topover
                                        interactive={true}
                                        content={this.renderPopoverInfo(
                                          this,
                                          IPCurrent.ip,
                                          pathFileSub[jsonSRV[group].idgrupo][
                                            jsonSRV[group].idmidia
                                          ]
                                        )}
                                      >
                                        <img
                                          src={
                                            pathFileSub[jsonSRV[group].idgrupo]
                                              ? connection_platform.type_connect +
                                                "://" +
                                                ipcurrent +
                                                pathFileSub[
                                                  jsonSRV[group].idgrupo
                                                ][jsonSRV[group].idmidia]
                                              : null
                                          }
                                          alt=""
                                        />
                                      </Topover>
                                    );
                                  }
                                })()}
                              </div>
                              <div className="inner">
                                <div className="about-user">
                                  <div className="nome is-poppins">
                                    {(() => {
                                      // eslint-disable-next-line default-case
                                      switch (
                                        parseInt(
                                          queueMediaidSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia]
                                        )
                                      ) {
                                        case 1:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={PHONENEW}
                                              alt=""
                                            />
                                          );
                                        case 2:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={WEBCHATNEW}
                                              alt=""
                                            />
                                          );
                                        case 3:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={MIDIAEMAIL}
                                              alt=""
                                            />
                                          );
                                        case 4:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={FACEBOOKNEW}
                                              alt=""
                                            />
                                          );
                                        case 5:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={WHATSAPPNEW}
                                              alt=""
                                            />
                                          );
                                        case 6:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={INSTAGRAM}
                                              alt=""
                                            />
                                          );
                                        case 8:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={MIDIATELEGRAM}
                                              alt=""
                                            />
                                          );
                                        case 9:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={TWITTER}
                                              alt=""
                                            />
                                          );
                                        case 10:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={LINKEDIN}
                                              alt=""
                                            />
                                          );
                                        case 11:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={GOOGLEGBM}
                                              alt=""
                                            />
                                          );
                                        case 15:
                                          return (
                                            <img
                                              className="prox-atend__enqueued-icon"
                                              src={TEAMS}
                                              alt=""
                                            />
                                          );
                                        default:
                                          return <></>;
                                      }
                                    })()}
                                    <span className="nome__text is-poppins">
                                      {queueContactnameSub[
                                        jsonSRV[group].idgrupo
                                      ][jsonSRV[group].idmidia] !== " "
                                        ? createJSON(
                                            queueContactnameSub[
                                              jsonSRV[group].idgrupo
                                            ][jsonSRV[group].idmidia]
                                          )
                                        : queueCallerSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia]}
                                    </span>
                                  </div>
                                  <div
                                    className="criticidade normal"
                                    data-tippy="Normal"
                                    tabIndex="0"
                                  >
                                    •
                                  </div>
                                </div>

                                <div className="title">
                                  <div className="title__top">
                                    {(() => {
                                      var now;
                                      var antes;
                                      var duracao = 0;
                                      var checkItem = false;

                                      if (IPCurrent.difftime < 0) {
                                        antes =
                                          maxcallqueueFormatSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia];
                                        now = Moment()
                                          .add(
                                            Math.round(IPCurrent.difftime),
                                            "seconds"
                                          )
                                          .format("YYYY/MM/DD HH:mm:ss");
                                        duracao = Moment(now).diff(
                                          antes,
                                          "seconds"
                                        );
                                        checkItem = true;
                                      } else {
                                        antes =
                                          maxcallqueueFormatSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia];
                                        now = Moment()
                                          .subtract(
                                            Math.round(IPCurrent.difftime),
                                            "seconds"
                                          )
                                          .format("YYYY/MM/DD HH:mm:ss");
                                        duracao = Moment(now).diff(
                                          antes,
                                          "seconds"
                                        );
                                        checkItem = true;
                                      }

                                      return (
                                        <div className="user-time active">
                                          <i className="material-icons">
                                            query_builder
                                          </i>{" "}
                                          <span className="time">
                                            <TimeCounterMinute
                                              horario={
                                                duracao < 0
                                                  ? 0
                                                  : parseInt(duracao)
                                              }
                                              key={
                                                queueQueueidSub[
                                                  jsonSRV[group].idgrupo
                                                ][jsonSRV[group].idmidia]
                                              }
                                            />{" "}
                                          </span>
                                        </div>
                                      );
                                    })()}
                                    <div className="actions">
                                      <a
                                        className="phone"
                                        onClick={() =>
                                          this.props.SolicitarChamada(
                                            InfoUsers,
                                            queueScriptidSub[
                                              jsonSRV[group].idgrupo
                                            ][jsonSRV[group].idmidia],
                                            queueCdridSub[
                                              jsonSRV[group].idgrupo
                                            ][jsonSRV[group].idmidia],
                                            queueMediaidSub[
                                              jsonSRV[group].idgrupo
                                            ][jsonSRV[group].idmidia],
                                            StatusAgent.status,
                                            IPCurrent
                                          )
                                        }
                                        data-tippy="Atender chamada"
                                      >
                                        <i className="material-icons">call</i>
                                      </a>
                                      &nbsp;
                                      <Popover
                                        trigger="click"
                                        boundary="window"
                                        placement="right"
                                        multiple={true}
                                        interactive={true}
                                        content={this.renderPopover(
                                          this,
                                          queueCallerSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia],
                                          queueContactnameSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia],
                                          queueCdridSub[jsonSRV[group].idgrupo][
                                            jsonSRV[group].idmidia
                                          ],
                                          queueQueueidSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia],
                                          queueGeralSub[jsonSRV[group].idgrupo][
                                            jsonSRV[group].idmidia
                                          ],
                                          InfoUsers
                                        )}
                                      >
                                        <a
                                          className="info tippy-context-menu"
                                          data-tooltip="Mais informações"
                                          data-template="info-fila"
                                        >
                                          <i className="material-icons">info</i>
                                        </a>
                                      </Popover>
                                    </div>
                                  </div>
                                </div>
                                <div className="details active">
                                  <div className="item details__text">
                                    <i className="material-icons">smartphone</i>{" "}
                                    {
                                      queueCallerSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ]
                                    }
                                  </div>
                                  <div className="item pct100  details__text">
                                    <i className="material-icons">
                                      report_problem
                                    </i>{" "}
                                    {
                                      queueCalledSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ]
                                    }
                                  </div>
                                  <div className="item pct100  details__text">
                                    <i className="material-icons">
                                      settings_phone
                                    </i>{" "}
                                    Qtde. de tentativas:{" "}
                                    <span>
                                      {
                                        queueRecv_countSub[
                                          jsonSRV[group].idgrupo
                                        ][jsonSRV[group].idmidia]
                                      }
                                    </span>
                                  </div>
                                  <Topover
                                    interactive={true}
                                    boundary="window"
                                    placement="left"
                                    content={this.renderPopoverInfo2(
                                      this,
                                      queueObsSub[jsonSRV[group].idgrupo][
                                        jsonSRV[group].idmidia
                                      ]
                                    )}
                                  >
                                    <div
                                      className="item pct100  details__text qtd-retorno tippy-context-menu"
                                      data-tippy-placement="right"
                                      data-template="qtd-retorno"
                                    >
                                      <i className="material-icons">
                                        phone_callback
                                      </i>{" "}
                                      Qtde. de retorno:{" "}
                                      <span className="details__text-qtd">
                                        {" "}
                                        {
                                          queueCallback_countSub[
                                            jsonSRV[group].idgrupo
                                          ][jsonSRV[group].idmidia]
                                        }
                                      </span>
                                    </div>
                                  </Topover>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    })()}

                    <div className="box__body sec">
                      <div className="card card--op card--justify">
                        <div className="card__number card__number--op">
                          {
                            desempenhoTotalFilaSub[jsonSRV[group].idgrupo][
                              jsonSRV[group].idmidia
                            ]
                          }{" "}
                          clientes em fila
                        </div>
                      </div>

                      <div className="card">
                        <div className="">
                          <div className="card__text">Clientes recebidos:</div>
                          <div className="card__number">
                            {jsonSRV[group].qtde_recebidas} clientes
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="">
                          <div className="card__text">
                            Clientes atendidos:
                            <div className="card__number">
                              {(
                                (jsonSRV[group].qtde_atendidas /
                                  jsonSRV[group].qtde_recebidas) *
                                100
                              ).toFixed(2)}
                              %
                            </div>
                          </div>
                          <div className="card__title">
                            {jsonSRV[group].qtde_atendidas} Clientes
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="">
                          <div className="card__text">
                            Tempo médio de atendimento:
                          </div>
                          <div className="card__number">
                            {TimeFormat.fromS(
                              jsonSRV[group].duracao_atendidas > 0
                                ? parseInt(
                                    parseInt(jsonSRV[group].duracao_atendidas) /
                                      parseInt(jsonSRV[group].qtde_atendidas)
                                  )
                                : 0,
                              "hh:mm:ss"
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="">
                          <div className="card__text">
                            Clientes abandonados:
                            <div className="card__number">
                              {(
                                (jsonSRV[group].qtde_abandonada /
                                  jsonSRV[group].qtde_recebidas) *
                                100
                              ).toFixed(2)}
                              %
                            </div>
                          </div>
                          <div className="card__title">
                            {jsonSRV[group].qtde_abandonada} Clientes
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="">
                          <div className="card__text">
                            Tempo médio de abandono:
                          </div>
                          <div className="card__number">
                            {TimeFormat.fromS(
                              parseInt(jsonSRV[group].duracao_abandonada_fila) >
                                0 &&
                                parseInt(jsonSRV[group].qtde_abandonada) > 0
                                ? parseInt(
                                    parseInt(
                                      jsonSRV[group].duracao_abandonada_fila
                                    ) / parseInt(jsonSRV[group].qtde_abandonada)
                                  )
                                : 0,
                              "hh:mm:ss"
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="">
                          <div className="card__text">
                            Tempo médio de espera para atendimento:
                          </div>
                          <div className="card__number">
                            {" "}
                            {TimeFormat.fromS(
                              jsonSRV[group].duracao_fila > 0
                                ? parseInt(
                                    parseInt(jsonSRV[group].duracao_fila) /
                                      parseInt(jsonSRV[group].qtde_fila_atd)
                                  )
                                : 0,
                              "hh:mm:ss"
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="">
                          <div className="card__text">
                            Maior tempo de espera para atendimento:
                          </div>
                          <div className="card__number">
                            {TimeFormat.fromS(
                              jsonSRV[group].duracao_maxima_fila > 0
                                ? parseInt(jsonSRV[group].duracao_maxima_fila)
                                : 0,
                              "hh:mm:ss"
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card">
                        <div className="">
                          <div className="card__text">
                            Clientes transferidos:
                          </div>
                          <div className="card__number">
                            {jsonSRV[group].qtde_transferida} clientes
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            {/* --------------------------------------------------------------------------------------------             */}

            <div
              className="modal micromodal-slide"
              id="modal__anotacoes_manager"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__anotacoes__title"
                >
                  <header className="modal__header">
                    <h2 className="modal__title" id="modal__anotacoes__title">
                      Anotações
                    </h2>
                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <main
                    className="modal__content"
                    id="modal__anotacoes__content"
                  >
                    <div className="anotc__info">
                      <p className="anotc__name  is-poppins">
                        {this.state.nameCli}
                      </p>
                      <i className="material-icons anotc__icon">note</i>{" "}
                      <span className="anotc__info-text">
                        Total de{" "}
                        <span className="anotc__counter">
                          {this.state.totalAnotations}
                        </span>{" "}
                        anotações
                      </span>
                    </div>
                    <div className="anotc__wrapper">
                      <div className="anotc__mp">
                        <div className="anotc__mp-ctrL">
                          <div className="anotc__mp-date">
                            <p className="anotc__mp-date-text">
                              Deseja buscar as anotação de qual período?
                            </p>
                            <div className="anotc__mp-date-wrapper">
                              <span className="anotc__mp-date-span">De:</span>
                              <input
                                type="date"
                                className="anotc__mp-date-start"
                                defaultValue={this.datatimeinitmanager}
                                ref={(input) => (this.dataInitmanager = input)}
                              />
                              <span className="anotc__mp-date-span">Até:</span>
                              <input
                                type="date"
                                className="anotc__mp-date-end"
                                defaultValue={this.datatimefimmanager}
                                ref={(input) => (this.dataFimmanager = input)}
                              />
                            </div>
                          </div>
                          <div className="anotc__mp-critic">
                            <p className="anotc__mp-critic-text">
                              E com qual nível de criticidade?
                            </p>
                            <div className="anotc__mp-critic-wrapper">
                              <button
                                className="anotc__mp-critic-btn"
                                onClick={this.ShowCriticitys.bind(this)}
                              >
                                {this.state.critSelec}
                                <i className="anotc__mp-critic-icon material-icons">
                                  keyboard_arrow_down
                                </i>
                              </button>
                              <div
                                className={
                                  this.state.buttonShowCriticits
                                    ? "anotc__mp-critic-options active"
                                    : "anotc__mp-critic-options"
                                }
                              >
                                <ul className="anotc__mp-critic-list">
                                  <li
                                    className="anotc__mp-critic-item"
                                    onClick={this.SelectCriticitys.bind(
                                      this,
                                      "",
                                      "Todos",
                                      ""
                                    )}
                                  >
                                    <span className="anotc__mp-critic-dot">
                                      •
                                    </span>
                                    Todos
                                  </li>
                                  {this.state.DescAnotacoes.map((desc) => (
                                    <li
                                      key={desc.id}
                                      className="anotc__mp-critic-item"
                                      onClick={this.SelectCriticitys.bind(
                                        this,
                                        desc.class_criticality,
                                        desc.description,
                                        desc.id
                                      )}
                                    >
                                      <span
                                        className={
                                          "anotc__mp-critic-dot " +
                                          desc.class_criticality
                                        }
                                      >
                                        •
                                      </span>
                                      {desc.description}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                          <button
                            className="anotc__mp-btn"
                            onClick={(event) =>
                              this.buttonSearchAnotation(event)
                            }
                          >
                            Filtrar
                          </button>
                        </div>

                        <div className="anotc__mp-result">
                          <div className="anotc__mp-search">
                            <span className="material-icons anotc__mp-search-icon">
                              expand_less
                            </span>
                            <span className="material-icons anotc__mp-search-icon">
                              expand_more
                            </span>
                            <input
                              type="text"
                              className="anotc__mp-search-input"
                              placeholder="Pesquisar..."
                            />
                            <button className="anotc__mp-search-btn">
                              Concluir
                            </button>
                          </div>

                          <ul className="anotc__mp-result-list">
                            {this.state.detailsAnotations.map((details) => (
                              <li
                                key={details.id}
                                className="anotc__mp-result-item"
                              >
                                <button className="anotc__mp-result-avatar">
                                  <img src="build/images/cliente.svg" alt="" />
                                </button>
                                <a
                                  className="anotc__mp-result-btn"
                                  onClick={(event) =>
                                    this.checkExpandLearnQueue(
                                      event,
                                      details.id
                                    )
                                  }
                                >
                                  <span className="anotc__mp-result-span material-icons">
                                    {this.state.buttonLearnMore ||
                                    this.state.expandLearn.indexOf(
                                      details.id
                                    ) != -1
                                      ? "remove_circle_outline"
                                      : "add_circle_outline"}
                                  </span>
                                  <span
                                    className={
                                      this.state.buttonLearnMore ||
                                      this.state.expandLearn.indexOf(
                                        details.id
                                      ) != -1
                                        ? "hack"
                                        : "hack active"
                                    }
                                  >
                                    {" "}
                                    Leia mais
                                  </span>
                                  <span
                                    className={
                                      this.state.buttonLearnMore ||
                                      this.state.expandLearn.indexOf(
                                        details.id
                                      ) != -1
                                        ? "hack active"
                                        : "hack"
                                    }
                                  >
                                    {" "}
                                    Leia menos
                                  </span>
                                </a>
                                <div className="anotc__mp-result-item-top">
                                  <div className="anotc__mp-result-item-info">
                                    <p className="anotc__mp-result-item-name">
                                      {this.state.nameCli}
                                    </p>
                                    <p className="anotc__mp-result-item-title">
                                      {details.usuario_anotacao}
                                    </p>
                                  </div>
                                  <div className="anotc__mp-result-item-critic">
                                    <span
                                      className={
                                        "anotc__mp-result-item-level " +
                                        details.class_criticality
                                      }
                                    >
                                      {details.desc_criticidade}
                                    </span>
                                    <span className="anotc__mp-result-item-fulltime">
                                      {details.data_anotacao +
                                        " - " +
                                        details.hora_anotacao}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className={
                                    this.state.buttonLearnMore ||
                                    this.state.expandLearn.indexOf(
                                      details.id
                                    ) != -1
                                      ? "anotc__mp-result-item-content auto"
                                      : "anotc__mp-result-item-content"
                                  }
                                >
                                  {details.desc_anotacao}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="flab">
                      <a className="flab__button">
                        <div className="material-icons">add</div>
                      </a>
                      <div className="flab__related">
                        {/* onclick="toggleModal('modal__anotacoes-adicionar')"  */}
                        <a
                          className="btn--add-anotc flab__related__button tippy-default"
                          data-tippy-content="Adicionar uma anotação"
                          data-tippy-theme="light"
                          data-tippy-placement="left"
                        >
                          <div className="material-icons">note_add</div>
                        </a>
                        <a
                          className="btn--search-anotc flab__related__button tippy-default"
                          data-tippy-content="Adicionar em uma anotação"
                          data-tippy-theme="light"
                          data-tippy-placement="left"
                        >
                          <div className="material-icons">search</div>
                        </a>
                      </div>
                      <div className="flab__overlay"></div>
                    </div>
                  </main>
                </div>
              </div>
            </div>

            {/* Fim do Modal de Anotações */}

            {/* Modal de Mensagens Favoritas */}
            <div
              className="modal micromodal-slide"
              id="modal__mensagens-favoritas_manager"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__mensagens-favoritas__title"
                >
                  <header className="modal__header">
                    <h2
                      className="modal__title"
                      id="modal__mensagens-favoritas__title"
                    >
                      Mensagens favoritas
                    </h2>
                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <main
                    className="modal__content"
                    id="modal__mensagens-favoritas__content"
                  >
                    <div className="msg-fav__info">
                      <p className="msg-fav__name  is-poppins">
                        {this.state.nameCli}
                      </p>
                      <i className="material-icons msg-fav__icon">note</i>{" "}
                      <span className="msg-fav__info-text">
                        Total de{" "}
                        <span className="msg-fav__counter">
                          {this.state.totalMarkstar}
                        </span>{" "}
                        mensagens
                      </span>
                    </div>
                    <div className="msg-fav__wrapper">
                      <div className="msg-fav__mp">
                        <div className="msg-fav__mp-ctrL">
                          <p className="msg-fav__mp-text">Período:</p>
                          <div className="msg-fav__mp-date">
                            <div className="msg-fav__mp-date-wrapper">
                              <span className="msg-fav__mp-date-span">De:</span>
                              <input
                                type="date"
                                defaultValue={this.datatimeinitmanager}
                                className="msg-fav__mp-date-start"
                                ref={(input) =>
                                  (this.dataInitMarkmanager = input)
                                }
                              />
                              <span className="msg-fav__mp-date-span">
                                Até:
                              </span>
                              <input
                                type="date"
                                className="msg-fav__mp-date-end"
                                defaultValue={this.datatimefimmanager}
                                ref={(input) =>
                                  (this.dataFimMarkmanager = input)
                                }
                              />
                            </div>
                          </div>
                          <button
                            className="msg-fav__mp-btn"
                            onClick={(event) =>
                              this.buttonSearchMarkstar(event)
                            }
                          >
                            Filtrar
                          </button>
                        </div>
                        {/* <!-- END CTRL --> */}
                        <div className="msg-fav__mp-result">
                          <ul className="msg-fav__mp-list">
                            {this.state.detailsMarkstar.map((dmark) =>
                              (() => {
                                var positmessage1 = "";
                                var positmessage2 = "";
                                if (dmark.is_from_agent === true) {
                                  positmessage1 = " right";
                                }
                                if (dmark.mimetypeid == "1") {
                                  return (
                                    <li
                                      key={dmark.id}
                                      className={
                                        "msg-fav__mp-item" + positmessage1
                                      }
                                    >
                                      <p className="msg-fav__mp-time">
                                        <span className="msg-fav__mp-day">
                                          {dmark.data_markstar}
                                        </span>{" "}
                                        -{" "}
                                        <span className="msg-fav__mp-hour">
                                          {dmark.hora_markstar}
                                        </span>
                                      </p>
                                      <div className="msg-fav__mp-bubble">
                                        {dmark.mensagem}
                                        <span className="msg-fav__mp-star material-icons">
                                          star
                                        </span>
                                      </div>
                                    </li>
                                  );
                                } else {
                                  if (dmark.mimetypeid == "2") {
                                    if (isJson(dmark.mensagem) === true) {
                                      let json = JSON.parse(dmark.mensagem);
                                      let options = json.options;
                                      let i = 1;
                                      var opcoes = [];
                                      for (i in options) {
                                        opcoes.push(i + " - " + options[i][1]);
                                      }
                                      return (
                                        <li
                                          className={
                                            "msg-fav__mp-item" + positmessage1
                                          }
                                        >
                                          {dmark.mensagem}
                                        </li>
                                      );
                                    } else {
                                      return (
                                        <li
                                          className={
                                            "msg-fav__mp-item" + positmessage1
                                          }
                                        >
                                          {dmark.mensagem}
                                        </li>
                                      );
                                    }
                                  } else if (
                                    dmark.mimetypeid == "3" ||
                                    dmark.mimetypeid == "5" ||
                                    dmark.mimetypeid > "6"
                                  ) {
                                    let separador = dmark.mensagem.split(".");
                                    switch (separador[1]) {
                                      case "jpeg":
                                      case "png":
                                      case "jpg":
                                        return (
                                          <li
                                            className={
                                              "msg-fav__mp-item" + positmessage1
                                            }
                                          >
                                            <p className="msg-fav__mp-time">
                                              <span className="msg-fav__mp-day">
                                                {dmark.data_markstar}
                                              </span>{" "}
                                              -{" "}
                                              <span className="msg-fav__mp-hour">
                                                {dmark.hora_markstar}
                                              </span>
                                            </p>
                                            <div className="msg-fav__mp-bubble">
                                              <div className="message left msg-fav__media">
                                                <div className="bubble-media">
                                                  <div
                                                    className="bubble-media__image"
                                                    onClick={(e) =>
                                                      this.VerifierImage(
                                                        e,
                                                        connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          dmark.mensagem,
                                                        "dmark"
                                                      )
                                                    }
                                                  >
                                                    {this.state.isOpen && (
                                                      <Lightbox
                                                        mainSrc={
                                                          this.state.urlimage
                                                        }
                                                        onCloseRequest={(e) =>
                                                          this.CloseImage(
                                                            e,
                                                            "dmark"
                                                          )
                                                        }
                                                      />
                                                    )}
                                                    <img
                                                      src={
                                                        connection_platform.type_connect +
                                                        "://" +
                                                        ipcurrent +
                                                        dmark.mensagem
                                                      }
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={JPG}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            dmark.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                dmark.mensagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <span className="msg-fav__mp-star material-icons">
                                                star
                                              </span>
                                            </div>
                                          </li>
                                        );
                                        break;
                                      case "pdf":
                                        return (
                                          <li
                                            className={
                                              "msg-fav__mp-item" + positmessage1
                                            }
                                          >
                                            <p className="msg-fav__mp-time">
                                              <span className="msg-fav__mp-day">
                                                {dmark.data_markstar}
                                              </span>{" "}
                                              -{" "}
                                              <span className="msg-fav__mp-hour">
                                                {dmark.hora_markstar}
                                              </span>
                                            </p>
                                            <div className="msg-fav__mp-bubble">
                                              <div className="message left msg-fav__media">
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={PDF}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            dmark.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>

                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                dmark.mensagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <span className="msg-fav__mp-star material-icons">
                                                star
                                              </span>
                                            </div>
                                          </li>
                                        );
                                        break;
                                      case "xls":
                                      case "xlsx":
                                      case "xlsm":
                                      case "doc":
                                      case "docx":
                                      case "ppt":
                                      case "pptx":
                                        return (
                                          <li
                                            className={
                                              "msg-fav__mp-item" + positmessage1
                                            }
                                          >
                                            <p className="msg-fav__mp-time">
                                              <span className="msg-fav__mp-day">
                                                {dmark.data_markstar}
                                              </span>{" "}
                                              -{" "}
                                              <span className="msg-fav__mp-hour">
                                                {dmark.hora_markstar}
                                              </span>
                                            </p>
                                            <div className="msg-fav__mp-bubble">
                                              <div className="message left msg-fav__media">
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={XLS}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            dmark.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>

                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                dmark.mensagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <span className="msg-fav__mp-star material-icons">
                                                star
                                              </span>
                                            </div>
                                          </li>
                                        );
                                        break;
                                      case "wav":
                                      case "mp3":
                                      case "ogg":
                                      case "mpeg":
                                        return (
                                          <li
                                            className={
                                              "msg-fav__mp-item" + positmessage1
                                            }
                                          >
                                            <p className="msg-fav__mp-time">
                                              <span className="msg-fav__mp-day">
                                                {dmark.data_markstar}
                                              </span>{" "}
                                              -{" "}
                                              <span className="msg-fav__mp-hour">
                                                {dmark.hora_markstar}
                                              </span>
                                            </p>
                                            <div className="msg-fav__mp-bubble">
                                              <div className="message left msg-fav__media">
                                                <div className="bubble-media">
                                                  <div className="bubble-media__playerBar">
                                                    <audio controls>
                                                      <source
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          dmark.mensagem
                                                        }
                                                        type="audio/ogg"
                                                      />
                                                      <source
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          dmark.mensagem
                                                        }
                                                        type="audio/mpeg"
                                                      />
                                                      Your browser.
                                                    </audio>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={MP3}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            dmark.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>

                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                dmark.mensagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <span className="msg-fav__mp-star material-icons">
                                                star
                                              </span>
                                            </div>
                                          </li>
                                        );
                                        break;
                                      case "mp4":
                                        return (
                                          <li
                                            className={
                                              "msg-fav__mp-item" + positmessage1
                                            }
                                          >
                                            <p className="msg-fav__mp-time">
                                              <span className="msg-fav__mp-day">
                                                {dmark.data_markstar}
                                              </span>{" "}
                                              -{" "}
                                              <span className="msg-fav__mp-hour">
                                                {dmark.hora_markstar}
                                              </span>
                                            </p>
                                            <div className="msg-fav__mp-bubble">
                                              <div className="message left msg-fav__media">
                                                <div className="bubble-media">
                                                  <div className="bubble-media__video">
                                                    <video
                                                      className="bubble-media__video-frame"
                                                      controls
                                                    >
                                                      <source
                                                        className="bubble-media__video-file"
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          dmark.mensagem
                                                        }
                                                        type="video/mp4"
                                                      />
                                                      Seu navegador nao suporta
                                                      esse tipo de arquivo.
                                                    </video>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={AVI}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            dmark.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                dmark.mensagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              </div>
                                              <span className="msg-fav__mp-star material-icons">
                                                star
                                              </span>
                                            </div>
                                          </li>
                                        );
                                        break;
                                      default:
                                    }
                                  }
                                }
                              })()
                            )}
                          </ul>
                        </div>
                        {/* <!-- MP RESULT --> */}
                      </div>
                      {/* <!-- END MP --> */}
                      <div className="msg-fav__null">
                        <img
                          src="build/images/msg-fav__null.svg"
                          alt=""
                          className="msg-fav__null-img"
                        />
                        <h3 className="is-poppins msg-fav__null-title">
                          Voce não possui{" "}
                          <span className="is-poppins is-poppins--bold">
                            mensagens favoritas.
                          </span>
                        </h3>
                        <p className="msg-fav__null-text">
                          Clique no ícone da estrela no canto inferior de cada
                          mensagem para marcá-la como favorita. Assim, você
                          poderá encontrá-la depois aqui.
                        </p>
                      </div>
                    </div>
                  </main>
                </div>
              </div>
            </div>

            {/* Fim do Modal Mensagens Favoritas */}

            {/* Modal Arquivos Compartilhados */}

            <div
              className="modal micromodal-slide"
              id="modal__arquivos-compartilhados_manager"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__arquivos-compartilhados__title"
                >
                  <header className="modal__header">
                    <h2
                      className="modal__title"
                      id="modal__arquivos-compartilhados__title"
                    >
                      Arquivos compartilhados
                    </h2>
                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <main
                    className="modal__content"
                    id="modal__arquivos-compartilhados__content"
                  >
                    <div className="arq-comp__info">
                      <p className="arq-comp__name  is-poppins">
                        {this.state.nameCli}
                      </p>
                      <i className="material-icons arq-comp__icon">
                        insert_drive_file
                      </i>{" "}
                      <span className="arq-comp__info-text">
                        Total de{" "}
                        <span className="arq-comp__counter">
                          {this.state.totalFiles}
                        </span>{" "}
                        arquivo&#x28;s&#x29;
                      </span>
                    </div>
                    <div className="arq-comp__sub-panel">
                      <p className="arq-comp__text">
                        Use os campos abaixo para filtrar a sua pesquisa
                      </p>
                      <div className="arq-comp__sub-panel__grid">
                        <div className="arq-comp__time-panel">
                          <p className="arq-comp__text">Periodo:</p>
                          <div className="arq-comp__ctrls">
                            <span className="arq-comp__span ml-0">De:</span>
                            <input
                              type="date"
                              defaultValue={this.timearqinitmanager}
                              ref={(input) => (this.timearqinitmanager = input)}
                              className="arq-comp__start"
                            />
                            <span className="arq-comp__span">Até:</span>
                            <input
                              type="date"
                              defaultValue={this.timearqfimmanager}
                              ref={(input) => (this.timearqfimmanager = input)}
                              className="arq-comp__end"
                            />
                          </div>
                        </div>
                        <div className="arq-comp__format-panel">
                          <p className="arq-comp__text">Formato:</p>
                          <div style={{ display: "none" }}>
                            <input
                              type="text"
                              defaultValue={
                                "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18"
                              }
                              ref={(input) => (this.mimetypeids = input)}
                              className="mimetype"
                            />
                            <input
                              type="text"
                              defaultValue={"2,4,5"}
                              ref={(input) => (this.midias = input)}
                              className="midias"
                            />
                          </div>
                          <div className="arq-comp__ctrls">
                            <button
                              type="date"
                              className="arq-comp__format-btn"
                              onClick={this.ShowChoiceFormat.bind(this)}
                            >
                              {this.state.defaultValueFormat}{" "}
                              <span className="material-icons">
                                expand_more
                              </span>
                            </button>
                            <ul
                              className={
                                this.state.buttonShowFormatsFile
                                  ? "arq-comp__list arq-comp__format-list active"
                                  : "arq-comp__list arq-comp__format-list"
                              }
                            >
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(
                                    event,
                                    "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18",
                                    "Todos"
                                  )
                                }
                              >
                                <span className="arq-comp__radio"></span> Todos
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "5", "PDF")
                                }
                              >
                                <span className="arq-comp__radio"></span> PDF
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "10,11,14", "DOC")
                                }
                              >
                                <span className="arq-comp__radio"></span> DOC
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "8,9", "XLS")
                                }
                              >
                                <span className="arq-comp__radio"></span> XLS
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "12,13", "PPT")
                                }
                              >
                                <span className="arq-comp__radio"></span> PPT
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "7", "ZIP")
                                }
                              >
                                <span className="arq-comp__radio"></span> ZIP
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "3,18", "Imagem")
                                }
                              >
                                <span className="arq-comp__radio"></span> Imagem
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "4,6,15,17", "Áudio")
                                }
                              >
                                <span className="arq-comp__radio"></span> Áudio
                              </li>
                              <li
                                className="arq-comp__item"
                                onClick={(event) =>
                                  this.choiceFormat(event, "16", "Vídeo")
                                }
                              >
                                <span className="arq-comp__radio"></span> Vídeo
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="arq-comp__channel-panel">
                          <p className="arq-comp__text">Canal:</p>
                          <div className="arq-comp__ctrls">
                            <button
                              type="date"
                              onClick={this.ShowChoiceMidias.bind(this)}
                              className="arq-comp__channel-btn"
                            >
                              {this.state.defaultValueMidias}{" "}
                              <span className="material-icons">
                                expand_more
                              </span>
                            </button>
                            <ul
                              className={
                                this.state.buttonShowMidias
                                  ? "arq-comp__list arq-comp__format-list active"
                                  : "arq-comp__list arq-comp__format-list"
                              }
                            >
                              <li
                                className="arq-comp__item"
                                id="Todos"
                                onClick={(event) =>
                                  this.choiceMidia(event, "5,4,2", "Todos")
                                }
                              >
                                <span
                                  id="Todos"
                                  className="arq-comp__radio"
                                ></span>{" "}
                                Todos
                              </li>
                              <li
                                className="arq-comp__item"
                                id="Whatsapp"
                                onClick={(event) =>
                                  this.choiceMidia(event, "5", "Whatsapp")
                                }
                              >
                                <span
                                  id="Whatsapp"
                                  className="arq-comp__radio"
                                ></span>{" "}
                                Whatsapp
                              </li>
                              <li
                                className="arq-comp__item"
                                id="Facebook"
                                onClick={(event) =>
                                  this.choiceMidia(event, "4", "Facebook")
                                }
                              >
                                <span
                                  id="Facebook"
                                  className="arq-comp__radio"
                                ></span>{" "}
                                Facebook
                              </li>
                              <li
                                className="arq-comp__item"
                                id="Webchat"
                                onClick={(event) =>
                                  this.choiceMidia(event, "2", "Webchat")
                                }
                              >
                                <span
                                  id="Webchat"
                                  className="arq-comp__radio"
                                ></span>{" "}
                                Webchat
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className="arq-comp__ctrls">
                          <button
                            className="arq-comp__search-btn"
                            onClick={(event) =>
                              this.buttonSearchFileCompart(event)
                            }
                          >
                            Filtrar
                          </button>
                        </div>
                      </div>

                      <div className="arq-comp__content">
                        <div className="arq-comp__table">
                          <div className="arq-comp__t-head">
                            <div className="arq-comp__t-col1 sort-by__btn">
                              <i className="material-icons">sort_by_alpha</i>
                            </div>
                            <div className="arq-comp__t-col2">Nome:</div>
                            <div className="arq-comp__t-col3">Data:</div>
                            <div className="arq-comp__t-col4">Tamanho:</div>
                            <div className="arq-comp__t-col5">Canal:</div>
                          </div>
                          <div className="arq-comp__t-body">
                            {this.state.detailsFileShared.map((dfilesh) => (
                              <div
                                className="arq-comp__t-item"
                                id="01"
                                key={dfilesh.id}
                                onClick={(event) =>
                                  this.showExpandVisual(event, dfilesh.id)
                                }
                              >
                                <div
                                  className={
                                    this.state.optionsActionsFile.indexOf(
                                      dfilesh.id
                                    ) != -1
                                      ? "arq-comp__t-item__context id-01 active"
                                      : "arq-comp__t-item__context id-01"
                                  }
                                >
                                  <div className="context__label special">
                                    <a
                                      className="context__content"
                                      href={
                                        connection_platform.type_connect +
                                        "://" +
                                        ipcurrent +
                                        dfilesh.mensagem
                                      }
                                      target="_blank"
                                      download
                                    >
                                      <span className="material-icons">
                                        visibility
                                      </span>
                                      <span className="context__text">
                                        Visualizar
                                      </span>
                                    </a>
                                  </div>
                                  <div className="context__label">
                                    <div
                                      className="context__content"
                                      onClick={(event) =>
                                        this.DonwloadFile(
                                          event,
                                          connection_platform.type_connect +
                                            "://" +
                                            ipcurrent +
                                            dfilesh.mensagem,
                                          dfilesh.mensagem
                                        )
                                      }
                                    >
                                      <span className="material-icons">
                                        get_app
                                      </span>
                                      <span className="context__text">
                                        Fazer download
                                      </span>
                                    </div>
                                  </div>
                                  {/* <div className="context__label">
                                <div className="context__content">
                                  <span className="material-icons">email</span>
                                  <span className="context__text">
                                    Enviar por email
                                  </span>
                                </div>
                              </div> */}
                                </div>
                                <div className="arq-comp__t-sort">
                                  <span className="arq-comp__t-sort_ft">
                                    {dfilesh.formato}
                                  </span>
                                </div>
                                <div className="arq-comp__t-name">
                                  Arquivo em {dfilesh.formato}
                                </div>
                                <div className="arq-comp__t-date">
                                  {dfilesh.data_envio}
                                </div>
                                {(() => {
                                  var url =
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    dfilesh.mensagem;
                                  {
                                    dbfileSize(dfilesh.filesize);
                                  }
                                })()}
                                <div className="arq-comp__t-size">
                                  {dbfileSize(dfilesh.filesize)}
                                </div>
                                <div className="arq-comp__t-channel">
                                  {(() => {
                                    if (dfilesh.idmidia === 5) {
                                      return (
                                        <img
                                          src={WHATSAPP}
                                          alt=""
                                          className="arq-comp__t-channel__icon"
                                        />
                                      );
                                    } else if (dfilesh.idmidia === 4) {
                                      return (
                                        <img
                                          src="build/images/t-facebook.svg"
                                          alt=""
                                          className="arq-comp__t-channel__icon"
                                        />
                                      );
                                    } else if (dfilesh.idmidia === 2) {
                                      return (
                                        <img
                                          src={WEBCHAT}
                                          alt=""
                                          className="arq-comp__t-channel__icon"
                                        />
                                      );
                                    }
                                  })()}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </main>
                </div>
              </div>
            </div>

            {/* Fim do Modal Arquivos Compartilhados */}

            {/* Modal de Historico */}

            <div
              className="modal micromodal-slide"
              id="modal__historico-atendimento_manager"
              aria-hidden="true"
              role="dialog"
            >
              <div className="modal__overlay" tabIndex="-1">
                <div
                  className="modal__container"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="modal__historico-atendimento__title"
                >
                  <header className="modal__header">
                    <h2
                      className="modal__title"
                      id="modal__historico-atendimento__title"
                    >
                      Interações
                    </h2>
                    <button
                      className="modal__close"
                      aria-label="Close modal"
                      data-micromodal-close
                    ></button>
                  </header>
                  <main
                    className="modal__content"
                    id="modal__historico-atendimento__content"
                  >
                    <div className="hist-atd__info">
                      <div className="hist-atd__info-items">
                        <p className="hist-atd__name  is-poppins">
                          {createJSON(this.state.cliente)}
                        </p>
                        <i className="material-icons hist-atd__icon">
                          question_answer
                        </i>{" "}
                        <span className="hist-atd__info-text">
                          Total de{" "}
                          <span className="hist-atd__counter">
                            {this.state.totalhistory}
                          </span>{" "}
                          interações&#x28;s&#x29;
                        </span>
                      </div>
                      <div className="hist-atd__info-pdf">
                        <a onClick={this.exportPDFWithMethod}>
                          <img src={ICONPDFEXPORT} />
                          Exportar PDF
                        </a>
                      </div>
                    </div>
                    <div className="hist-atd__ctrls">
                      <p className="hist-atd__text">Período</p>
                      <span className="hist-atd__span">De:</span>
                      <input
                        type="datetime-local"
                        defaultValue={this.timedefaultinitmanager}
                        ref={(input) => (this.datahistoryinitmanager = input)}
                        className="hist-atd__end"
                        id="hist_start_queue"
                      />
                      <span className="hist-atd__span">Até:</span>
                      <input
                        type="datetime-local"
                        defaultValue={this.timedefaultfimmanager}
                        ref={(input) => (this.datahistoryfimmanager = input)}
                        className="hist-atd__end"
                        id="hist_end_queue"
                      />
                      <button
                        className="hist-atd__search-btn"
                        onClick={this.SearchHistoryQueue.bind(
                          this,
                          this.state.cdrid,
                          this.state.cliente
                        )}
                      >
                        Filtrar
                      </button>
                    </div>
                    <div className="hist-atd__content">
                      <div
                        className={
                          this.state.showHistory
                            ? "hist-atd__search active"
                            : "hist-atd__search"
                        }
                      >
                        <span
                          onClick={(event) => this.handleKeyUp("less")}
                          className="material-icons hist-atd__search-icon"
                        >
                          expand_less
                        </span>
                        <span
                          onClick={(event) => this.handleKeyUp("more")}
                          className="material-icons hist-atd__search-icon"
                        >
                          expand_more
                        </span>
                        <input
                          onChange={(event) =>
                            this.setState({
                              searchText: event.target.value,
                              arrowterm: 0,
                            })
                          }
                          type="text"
                          className="hist-atd__search-input"
                          placeholder="Pesquisar..."
                        />
                        <button
                          onClick={this.SearchInHistory.bind(this)}
                          className="hist-atd__search-btn hist-atd__search-btn--two"
                        >
                          Concluir
                        </button>
                      </div>
                      <div className="hist-atd__channel-info">
                        <img
                          className="hist-atd__channel-info-icon"
                          style={{ display: "none" }}
                          src={WHATSAPP}
                          alt=""
                          width="20"
                          height="20"
                        />
                        <div className="hist-atd__channel-info-time">
                          Interações
                        </div>
                      </div>
                      <div
                        className="hist-atd__wrapper"
                        onScroll={this.handleScroll}
                      >
                        <div className="hist-atd__channel">
                          <div className="hist-atd__channel-chat active">
                            {this.state.history.map((history) => (
                              <div
                                key={history.id}
                                className={
                                  history.agente === true
                                    ? "message right"
                                    : "message left"
                                }
                              >
                                {(() => {
                                  dia = history.diaenvio;
                                  mes = history.mesenvio;
                                  ano = history.anoenvio;
                                  mes = meses.indexOf(mes);
                                  dia = dia + " de " + meses[mes - 1];
                                  if (
                                    ano < history.anoenvio ||
                                    ano > history.anoenvio
                                  )
                                    dia = dia + " de " + history.anoenvio;
                                  if (dia != auxdia) {
                                    dia = dia;
                                    auxdia = dia;
                                  } else {
                                    auxdia = dia;
                                    dia = "";
                                  }
                                })()}
                                <div id={history.id} className="time">
                                  {dia}
                                </div>
                                <div
                                  className="bubble"
                                  id={"manager_" + history.id}
                                >
                                  {(() => {
                                    if (history.replyid > 0) {
                                      var text = "";
                                      var array = [];
                                      var posit = "";
                                      checkreply = true;

                                      array = this.state.history.filter(
                                        (msg) =>
                                          parseInt(msg.id) ===
                                          parseInt(history.replyid)
                                      );
                                      if (array.length !== 0 && array) {
                                        posit = array[0].author;
                                        if (array[0].mimetypeid !== 1) {
                                          var url = array[0].messagem;
                                          url = url.substring(
                                            url.lastIndexOf(".") + 1
                                          );
                                          switch (url.toLowerCase()) {
                                            case "jpeg":
                                            case "png":
                                            case "jpg": {
                                              return (
                                                <a
                                                  href={
                                                    "#manager_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={FOTO}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      Imagem
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                            case "pdf":
                                              return (
                                                <a
                                                  href={
                                                    "#manager_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={DOC}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      PDF
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            case "xls":
                                            case "xlsx":
                                            case "xlsm":
                                            case "doc":
                                            case "docx":
                                            case "ppt":
                                            case "pptx": {
                                              return (
                                                <a
                                                  href={
                                                    "#manager_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={DOC}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      DOC
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                            case "wav":
                                            case "mp3":
                                            case "ogg":
                                            case "mpeg": {
                                              return (
                                                <a
                                                  href={
                                                    "#manager_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={AUDIO}
                                                        alt=""
                                                        width="12"
                                                      />{" "}
                                                      Áudio
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                            case "mp4": {
                                              return (
                                                <a
                                                  href={
                                                    "#manager_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      <img
                                                        src={VIDEO}
                                                        alt=""
                                                        width="15"
                                                      />{" "}
                                                      Vídeo
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                          }
                                        } else {
                                          text = array[0].messagem;
                                          if (text.length > 200)
                                            text = text.substr(0, 200) + "...";
                                          text = text.replace(/¿/gi, "\n");
                                          text = text.replace(/§/gi, "\r\n");
                                          return (
                                            <a
                                              href={
                                                "#manager_" + history.replyid
                                              }
                                            >
                                              <div className="reply-message active">
                                                <div className="reply-message__name">
                                                  {posit === "Me"
                                                    ? "Você"
                                                    : createJSON(
                                                        this.state.cliente
                                                      )}
                                                </div>
                                                <div className="reply-message__text">
                                                  {text}
                                                </div>
                                              </div>
                                            </a>
                                          );
                                        }
                                      }
                                    }
                                    //}
                                  })()}

                                  <div className="bubble-user-name">
                                    {checkreply === false
                                      ? history.agente === false
                                        ? createJSON(this.state.cliente)
                                        : history.username
                                      : null}
                                  </div>
                                  <div className="text">
                                    {(() => {
                                      let caption = history.caption;
                                      if (
                                        caption == "null" ||
                                        caption == null
                                      ) {
                                        caption = "";
                                      } else {
                                        caption = caption.replace(
                                          /\\n/g,
                                          "\r\n"
                                        );
                                      }
                                      var positmessage1 = "";
                                      var positmessage2 = "";
                                      if (history.is_from_agent === true) {
                                        positmessage1 = " right";
                                      }
                                      checkreply = false;
                                      if (history.mimetypeid == "1") {
                                        var mensagem_tratada = history.messagem;
                                        mensagem_tratada =
                                          history.messagem.replace(
                                            /\\n/gi,
                                            "\r\n"
                                          );
                                        mensagem_tratada =
                                          history.messagem.replace(/¿/gi, "\n");
                                        mensagem_tratada =
                                          mensagem_tratada.replace(
                                            /§/gi,
                                            "\r\n"
                                          );
                                        let valor = 1;
                                        try {
                                          mensagem_tratada =
                                            '{"' +
                                            valor +
                                            '": [{"mensagem_tratada":"' +
                                            mensagem_tratada +
                                            '"}]}';
                                          var obj =
                                            JSON.parse(mensagem_tratada);
                                          mensagem_tratada =
                                            obj[1][0].mensagem_tratada;
                                        } catch (e) {
                                          mensagem_tratada = history.messagem;
                                          mensagem_tratada =
                                            mensagem_tratada.replace(
                                              /\r\n/gi,
                                              "ªª"
                                            );
                                          mensagem_tratada =
                                            mensagem_tratada.replace(
                                              /\r\n/gi,
                                              "ªª"
                                            );
                                          mensagem_tratada =
                                            mensagem_tratada.replace(
                                              /[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! *  # ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g,
                                              ""
                                            );
                                          mensagem_tratada =
                                            '{"' +
                                            valor +
                                            '": [{"mensagem_tratada":"' +
                                            mensagem_tratada +
                                            '"}]}';
                                          var obj =
                                            JSON.parse(mensagem_tratada);
                                          mensagem_tratada =
                                            obj[1][0].mensagem_tratada;
                                          mensagem_tratada =
                                            mensagem_tratada.replace(
                                              /ªª/gi,
                                              "\r\n"
                                            );
                                        }
                                        return (
                                          <div>
                                            <Highlighter
                                              highlightClassName="YourHighlightClass"
                                              searchWords={searchWords}
                                              autoEscape={true}
                                              textToHighlight={mensagem_tratada}
                                              sanitize={latinize}
                                            />
                                            <span className="text__end-spacing"></span>
                                          </div>
                                        );
                                      } else {
                                        if (history.mimetypeid == "2") {
                                          if (
                                            isJson(history.messagem) === true
                                          ) {
                                            let json = JSON.parse(
                                              history.messagem
                                            );
                                            let options = json.options;
                                            let i = 1;
                                            var opcoes = [];
                                            for (i in options) {
                                              opcoes.push(
                                                i + " - " + options[i][1]
                                              );
                                            }
                                            return (
                                              <div>
                                                <Highlighter
                                                  highlightClassName="YourHighlightClass"
                                                  searchWords={searchWords}
                                                  autoEscape={true}
                                                  textToHighlight={
                                                    json.msg + " \r\n "
                                                  }
                                                  sanitize={latinize}
                                                />
                                                <Highlighter
                                                  highlightClassName="YourHighlightClass"
                                                  searchWords={searchWords}
                                                  autoEscape={true}
                                                  textToHighlight={opcoes.join(
                                                    "  \r\n  "
                                                  )}
                                                  sanitize={latinize}
                                                />
                                                <span className="text__end-spacing"></span>
                                              </div>
                                            );
                                          } else {
                                            return (
                                              <div>
                                                <Highlighter
                                                  highlightClassName="YourHighlightClass"
                                                  searchWords={searchWords}
                                                  autoEscape={true}
                                                  textToHighlight={
                                                    history.messagem
                                                  }
                                                />
                                                <span className="text__end-spacing"></span>
                                              </div>
                                            );
                                          }
                                        } else if (history.mimetypeid == "30") {
                                          if (
                                            isJson(history.messagem) === true
                                          ) {
                                            let json = JSON.parse(
                                              history.messagem
                                            );
                                            let options = json.options;
                                            let i = 1;
                                            var opcoes = [];
                                            for (i in options) {
                                              opcoes.push(
                                                i + " - " + options[i][1]
                                              );
                                            }
                                            if (json.MSG) {
                                              return (
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      json.MSG + " \r\n "
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={opcoes.join(
                                                      "  \r\n  "
                                                    )}
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              );
                                            } else if (json.URL) {
                                              return (
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      json.URL + " \r\n "
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={opcoes.join(
                                                      "  \r\n  "
                                                    )}
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              );
                                            }
                                          }
                                        } else if (
                                          history.mimetypeid == "3" ||
                                          history.mimetypeid == "4" ||
                                          history.mimetypeid == "5" ||
                                          history.mimetypeid >= "6"
                                        ) {
                                          let separador =
                                            history.messagem.split(".");
                                          switch (separador[1]) {
                                            case "jpeg":
                                            case "png":
                                            case "PNG":
                                            case "jpg":
                                              return (
                                                <div className="bubble-media">
                                                  <div
                                                    className="bubble-media__image"
                                                    onClick={(e) =>
                                                      this.VerifierImage(
                                                        e,
                                                        connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem,
                                                        "history"
                                                      )
                                                    }
                                                  >
                                                    {this.state.isOpen && (
                                                      <Lightbox
                                                        mainSrc={
                                                          this.state.urlimage
                                                        }
                                                        onCloseRequest={(e) =>
                                                          this.CloseImage(
                                                            e,
                                                            "history"
                                                          )
                                                        }
                                                      />
                                                    )}
                                                    <img
                                                      src={
                                                        connection_platform.type_connect +
                                                        "://" +
                                                        ipcurrent +
                                                        history.messagem
                                                      }
                                                      alt=""
                                                    />
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={JPG}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "pdf":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={PDF}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "xls":
                                            case "xlsx":
                                            case "xlsm":
                                            case "doc":
                                            case "docx":
                                            case "ppt":
                                            case "pptx":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={XLS}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "wav":
                                            case "mp3":
                                            case "ogg":
                                            case "mpeg":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__playerBar">
                                                    <audio controls>
                                                      <source
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem
                                                        }
                                                        type="audio/ogg"
                                                      />
                                                      <source
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem
                                                        }
                                                        type="audio/mpeg"
                                                      />
                                                      Your browser.
                                                    </audio>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={MP3}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            case "mp4":
                                              return (
                                                <div className="bubble-media">
                                                  <div className="bubble-media__video">
                                                    <video
                                                      className="bubble-media__video-frame"
                                                      controls
                                                    >
                                                      <source
                                                        className="bubble-media__video-file"
                                                        src={
                                                          connection_platform.type_connect +
                                                          "://" +
                                                          ipcurrent +
                                                          history.messagem
                                                        }
                                                        type="video/mp4"
                                                      />
                                                      Seu navegador nao suporta
                                                      esse tipo de arquivo.
                                                    </video>
                                                  </div>
                                                  <div className="bubble-media__mediaInfo">
                                                    <span className="bubble-media__fileType">
                                                      <img
                                                        className="bubble-media__fileIcon"
                                                        src={AVI}
                                                        alt=""
                                                      />
                                                    </span>
                                                    <span className="bubble-media__fileName">
                                                      <p className="bubble-media__text">
                                                        Nome do Arquivo
                                                      </p>
                                                      <br />
                                                      <div className="fileinfo__bar">
                                                        <span className="fileinfo__size">
                                                          {dbfileSize(
                                                            history.filesize
                                                          )}
                                                        </span>{" "}
                                                        •{" "}
                                                        <span className="fileinfo__type">
                                                          {""}
                                                        </span>
                                                      </div>
                                                    </span>
                                                    {(() => {
                                                      if (
                                                        InfoUsers.permdownload ===
                                                        true
                                                      ) {
                                                        return (
                                                          <div className="bubble-media__download">
                                                            <a
                                                              href={
                                                                connection_platform.type_connect +
                                                                "://" +
                                                                ipcurrent +
                                                                history.messagem
                                                              }
                                                              target="_blank"
                                                              download
                                                              className="bubble-media__btnDownload"
                                                            >
                                                              <i className="material-icons">
                                                                get_app
                                                              </i>
                                                            </a>
                                                          </div>
                                                        );
                                                      }
                                                    })()}
                                                  </div>
                                                </div>
                                              );
                                              break;
                                            default:
                                          }
                                        }
                                      }
                                    })()}
                                  </div>
                                  <div className="text">
                                    {(() => {
                                      let caption = history.caption;
                                      if (
                                        caption == "null" ||
                                        caption == null
                                      ) {
                                        caption = "";
                                      } else {
                                        caption = caption.replace(
                                          /\\n/g,
                                          "\r\n"
                                        );
                                      }
                                      return caption;
                                    })()}
                                  </div>
                                  <div className="bubble__info-content">
                                    <div className="fav fav--inside fav--right">
                                      {/* <i className="material-icons fav-icon">star_border</i> */}
                                    </div>
                                    <div className="bubble__info-content__time">
                                      {history.horaenvio}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </main>

                  <button
                    className="hist-atd__fab"
                    onClick={this.SearchInHistory.bind(this)}
                  >
                    <i className="material-icons">search</i>
                  </button>

                  <div className="modal__content__form__group modal__content__form__group--col-1">
                    <a
                      className="modal__content__form__group__button modal__content__form__group__button--text"
                      data-micromodal-close
                    >
                      <i className="material-icons" data-micromodal-close>
                        arrow_back
                      </i>
                      Voltar
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Fim do Modal de Historico */}
          </div>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__excluir_manager"
          aria-hidden="true"
          role="dialog"
        >
          <DeleteCallModal
            deletecdrid={this.state.deletecdrid}
            deletequeueid={this.state.deletequeueid}
            mediaid={this.state.mediaid}
          />
        </div>
        <input type="hidden" id="simulation_click" name="simulation_click" />
        <div
          style={{
            position: "absolute",
            right: "-9999999999999999999999999px",
            top: 0,
          }}
        >
          <PDFExport
            ref={(component) => (this.pdfExportComponent = component)}
            paperSize="A4"
          >
            <PdfDocument
              history={this.state.history}
              cliente={this.state.cliente}
              datapdfinit={this.state.datapdfinit}
              datapdfend={this.state.datapdfend}
              numero={this.state.clientpdf}
            />
          </PDFExport>
        </div>
      </div>
    );
  }

  exportPDFWithMethod = () => {
    savePDF(ReactDOM.findDOMNode(this.pdfExportComponent), {
      paperSize: "A4",
      margin: 10,
      fileName: this.state.cliente + "_" + this.state.clientpdf + ".pdf",
    });
  };
  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
